{
  "access.door.headline": "You're early.\nAgain.",
  "access.door.live": "Trading now",
  "access.door.note": "The terminal opens by invitation. The bot takes your place in the queue and tells you the moment it opens.",
  "access.door.telegram": "Continue with Telegram",
  "access.door.title": "Invite only",
  "access.waitlist.check_again": "Check again",
  "access.waitlist.come_back_note": "The terminal opens by invitation. This page checks on its own and opens the terminal the moment you are let in.",
  "access.waitlist.position": "Your place in line",
  "access.waitlist.share": "Your invite link · joined through it: {{count}}",
  "access.waitlist.sign_out": "Sign out",
  "access.waitlist.telegram_note": "The terminal opens by invitation. We will message you in Telegram when it is your turn.",
  "access.waitlist.title": "You are on the list",
  "analytics": "Analytics",
  "analytics.tabs.info": "Info",
  "analytics.tabs.trades": "Trades",
  "app-titlebar.forward": "Forward",
  "app-titlebar.maximize": "Maximize",
  "app-titlebar.minimize": "Minimize",
  "app-titlebar.open-in-browser": "Open in browser",
  "app.name": "kol.trade",
  "app.pitch": "Speed, simplicity, self-custody",
  "asset_one": "Asset",
  "asset_other": "Assets",
  "auth.auth-login-account-description": "You will get access to the trading functionality and other features.",
  "auth.auth-login-account-title": "To start trading log in to your account",
  "auth.continue": "Continue",
  "auth.create-local-password": "Create local password",
  "auth.create-pin-description": "Set the pincode for your security",
  "auth.create-pin-title": "Create Pincode",
  "auth.enter_password_to_unlock": "<0>Enter the password</0> to continue",
  "auth.enter-otp-description": "You logged in with a different IP",
  "auth.enter-otp-title": "Enter OTP",
  "auth.forget-password": "Forgot the password?",
  "auth.google-auth-error": "Unable to sign in with Google",
  "auth.google-auth-error-existence-check": "Unable to check if user exists",
  "auth.info.wallets": "We don’t store access to your wallets on our servers. Different devices have different wallets and passwords.",
  "auth.invalid-otp": "Invalid OTP. Please try again.",
  "auth.keychain-access-denied": "Unable to get data from system keychain",
  "auth.keychain-locked": "Keychain is locked",
  "auth.log-in": "Log In",
  "auth.log-in-to-your-account": "Log in to your account or create a new one",
  "auth.log-out": "Log Out",
  "auth.login": "Login",
  "auth.login-to-your-account": "Log in to your account",
  "auth.login-with-another-account": "Login with another account",
  "auth.login-with-google-loading": "Signing you in with Google...",
  "auth.login-with-telegram-loading": "Signing you in with Telegram...",
  "auth.login-with-username": "Login with username",
  "auth.logout": "Logout",
  "auth.logout-message": "Do you really want to log out from your profile?",
  "auth.me-request-error": "Unable to get user information",
  "auth.or-login-or-register": "or log in / sign up with",
  "auth.password": "Password",
  "auth.please-wait": "Please, wait",
  "auth.please-wait-description": "we receive information about your account",
  "auth.register": "Register",
  "auth.register.create-any-unique-username": "Choose a unique username",
  "auth.register.create-any-unique-username-available": "<0> {{username}} is available</0>",
  "auth.register.create-any-unique-username-checking": "<0> {{username}} is being checked</0>",
  "auth.register.create-any-unique-username-not-available": "<0> {{username}} is not available</0>",
  "auth.register.enter-referral-code": "Enter referral code (optional)",
  "auth.register.terms-of-service": "I agree with <0>Terms of Service</0> and <1>Privacy Policy</1>",
  "auth.registration": "Registration",
  "auth.repeat": "Repeat",
  "auth.sign-in": "Sign in",
  "auth.twitter-auth-error": "Unable to sign in with X",
  "auth.twitter-auth-error-existence-check": "Unable to check if user exists",
  "auth.unlock": "Unlock",
  "auth.unlock-your-wallets": "Unlock your wallets",
  "auth.username": "Username",
  "auth.username-length-error": "Username must be at least 3 characters long",
  "auth.username-not-available-error": "Username is already taken",
  "auth.welcome": "Welcome",
  "auth.wrong-credentials": "Invalid username or password. Please try again.",
  "auth.wrong-password": "Wrong password",
  "back_office.premium.change_error": "Error while transferring Premium to the new owner",
  "back_office.premium.change_success": "Premium has been successfully transferred to the new owner",
  "back_office.premium.id_or_token_required": "Specify either Premium ID or token address",
  "back_office.premium.new_deluge_id": "New owner kol.trade ID",
  "back_office.premium.new_owner_wallet": "New owner wallet address",
  "back_office.premium.new_tg_id": "New owner Telegram ID",
  "back_office.premium.premium_id": "Premium ID",
  "back_office.premium.submit": "Transfer premium",
  "back_office.premium.token_address": "Token address",
  "back_office.user.active": "Active",
  "back_office.user.block_user_confirm_block": "Are you sure you want to block {{name}}?",
  "back_office.user.block_user_confirm_unblock": "Are you sure you want to unblock {{name}}?",
  "back_office.user.blocked": "Blocked",
  "back_office.user.has_been_successfully_blocked": "User {{name}} has been successfully blocked",
  "back_office.user.has_been_successfully_unblocked": "User {{name}} has been successfully unblocked",
  "back-office.navigation.title": "Admin",
  "back-office.table.wallets": "Wallets",
  "basic.available": "{{amount}} available",
  "basic.cash": "cash",
  "basic.deposit_evm": "Ethereum, Base, BNB, Arbitrum",
  "basic.deposit_hint": "Send USDC to one of these addresses and it becomes your balance. You can buy on any supported chain with it.",
  "basic.deposit_solana": "Solana",
  "basic.deposit_title": "Top up your balance",
  "basic.deposit_more": "Deposit more",
  "basic.max": "Max",
  "basic.no_positions": "Nothing held yet",
  "basic.no_prices": "Prices unavailable",
  "basic.not_enough": "Not enough balance",
  "basic.nothing_held": "Nothing to sell",
  "basic.order_refused": "That order was refused. Try again in a moment.",
  "basic.prices_as_of": "Prices {{when}}",
  "basic.prices_stale": "Prices {{when}} — may be out of date",
  "basic.quick_buy_accepted": "Order accepted: {{amount}} of {{symbol}}",
  "basic.quick_buy_balance_unavailable": "Your balance cannot be read right now. Try again in a moment.",
  "basic.quick_buy_not_enough": "Not enough balance. Top it up to buy.",
  "basic.quick_buy_refused": "That buy did not go through. Try again in a moment.",
  "basic.sell_percent": "Sell {{percent}}% of {{symbol}}",
  "basic.unvalued": "Cost {{cost}}",
  "basic.you_hold": "You hold {{amount}} {{symbol}}",
  "blacklist-currencies.description": "Tokens in this list are hidden from your Explore feed. Unhide a token to see it in your feed again.",
  "blacklist-currencies.title": "Hidden tokens",
  "blacklist-currencies.unhide-tooltip": "Unhide token",
  "blacklist.currencies.hide-tooltip": "Hide token",
  "blacklist.currencies.tooltip": "Hidden tokens",
  "browser-mode.warning.big-title": "Warning",
  "browser-mode.warning.button": "Confirm and continue",
  "browser-mode.warning.description": "For maximum wallet security, it is strongly recommended to remove or disable all unnecessary browser extensions. Malicious or compromised extensions may monitor activity or interfere with transactions. Only keep extensions you fully trust and actively use.",
  "browser-mode.warning.heading": "Keep your wallets safe",
  "browser-mode.warning.title": "Pay attention",
  "bundler_one": "Bundler",
  "bundler_other": "Bundlers",
  "bundlers": "Bundlers",
  "comment.add_comment": "Add comment",
  "comment.comment_created": "Your comment has been added",
  "comment.comment_deleted": "Your comment has been deleted",
  "comment.comment_edited": "Your comment has been edited",
  "comment.comments": "Comments",
  "comment.comments_all": "All comments ({{count}})",
  "comment.comments_load_all": "Load All Comments ({{count}})",
  "comment.comments_one": "Comment ({{count}})",
  "comment.comments_other": "Comments ({{count}})",
  "comment.delete.confirmation.description": "This action cannot be undone.",
  "comment.delete.confirmation.title": "Are you sure you want to delete the comment?",
  "comment.history.empty-description": "The comments will appear here",
  "comment.history.empty-title": "Comments history is empty",
  "comment.image_attachment": "Image attachment",
  "comment.message.delete": "Delete",
  "comment.message.delete_as_admin": "Delete as admin",
  "comment.message.edit": "Edit",
  "comment.message.editing": "Editing",
  "comment.message.hyped_users_only": "Only <icon /> <hyped>Hyped users</hyped> can comment",
  "comment.message.placeholder": "Your comment",
  "comment.message.reply": "Reply",
  "comment.no_comments_description": "Be the first to comment on this token",
  "comment.no_comments_title": "No comments yet",
  "comment.replies": "Replies",
  "common.30d": "30d",
  "common.30d-pnl": "30D PnL",
  "common.5m-percent": "5M%",
  "common.action": "Action",
  "common.action_need_confirmation": "The action requires confirmation",
  "common.activate": "Activate",
  "common.activity": "Activity",
  "common.add": "Add",
  "common.add_file": "Add file",
  "common.additional_information": "Additional information",
  "common.address": "Address",
  "common.age": "Age",
  "common.ago": "{{time}} ago",
  "common.all": "All",
  "common.amount": "Amount",
  "common.apply": "Apply",
  "common.at": "at",
  "common.ath": "ATH",
  "common.ath_mkt_cap": "ATH Market Cap: {{value}}",
  "common.attention": "Attention!",
  "common.audit": "Audit",
  "common.auth": "Authorization",
  "common.auto": "Auto",
  "common.avg-mc-bs": "Avg MC B/S",
  "common.back": "Back",
  "common.back-to-top": "Back to top",
  "common.bal": "Bal",
  "common.balance": "Balance",
  "common.bought": "Bought",
  "common.by": "By",
  "common.cancel": "Cancel",
  "common.change": "Change",
  "common.change-for-n": "Change for <n />",
  "common.check": "Check",
  "common.clear": "Clear",
  "common.close": "Close",
  "common.closed-price": "Closed Price",
  "common.coins_held": "Coins held",
  "common.coins_one": "coin",
  "common.coins_other": "coins",
  "common.coming-soon": "Coming soon",
  "common.comments_other": "comments",
  "common.confirm": "Confirm",
  "common.connect": "Connect",
  "common.continue": "Continue",
  "common.weekday.1": "Mon",
  "common.weekday.2": "Tue",
  "common.weekday.3": "Wed",
  "common.weekday.4": "Thu",
  "common.weekday.5": "Fri",
  "common.weekday.6": "Sat",
  "common.weekday.7": "Sun",
  "common.copied": "Copied",
  "common.copied-to-clipboard": "Copied to clipboard",
  "common.copy": "Copy",
  "common.copy_address": "Copy address",
  "common.copy-to-clipboard": "Copy to clipboard",
  "common.cost": "Cost",
  "common.count": "Count",
  "common.create": "Create",
  "common.create_coin": "Create coin",
  "common.created": "Created",
  "common.created_at": "Created at",
  "common.created_coins": "Created coins",
  "common.d-premium": "Premium",
  "common.current": "Current",
  "common.date": "Date",
  "common.days_one": "{{count}} day",
  "common.days_other": "{{count}} days",
  "common.description": "Description",
  "common.dev_holdings": "Dev Holdings",
  "common.dev_wallet": "Dev Wallet",
  "common.dev-tokens": "Dev Tokens",
  "common.disable": "Disable",
  "common.disabled": "Disabled",
  "common.discord": "Discord",
  "common.dismiss": "Dismiss",
  "common.done": "Done",
  "common.download": "Download",
  "common.downloading": "Downloading",
  "common.edit": "Edit",
  "common.empty": "Empty",
  "common.empty-unfortunately": "Nothing here yet",
  "common.enabled": "Enabled",
  "common.entry-price": "Entry Price",
  "common.error": "Error",
  "common.error-range-exceeded": "Minimum values should not exceed maximum values",
  "common.example": "Example",
  "common.expires": "Expires",
  "common.explore": "Explore",
  "common.explore-tokens": "Explore Tokens",
  "common.export": "Export",
  "common.fdv": "FDV",
  "common.file-size-too-big": "File size is too large",
  "common.filter": "Filter",
  "common.filter_other": "Filters",
  "common.filter_reset": "Reset filter",
  "common.first_name": "First name",
  "common.follow": "Follow",
  "common.follower_one": "follower",
  "common.follower_other": "followers",
  "common.following_many": "following",
  "common.following_one": "following",
  "common.following_other": "following",
  "common.format.days_short": "{{count}}d",
  "common.format.hours_short": "{{count}}h",
  "common.format.minutes_short": "{{count}}m",
  "common.format.months_short": "{{count}}mo",
  "common.format.seconds_short": "{{count}}s",
  "common.format.weeks_short": "{{count}}w",
  "common.format.years_short": "{{count}}y",
  "common.funded": "Funded",
  "common.funded-amount": "Funded amount",
  "common.funding": "Funding",
  "common.get_help": "Get help",
  "common.globally": "globally",
  "common.go-home": "Go Home",
  "common.hash": "Hash",
  "common.history": "History",
  "common.holders": "Holders",
  "common.holding": "Holding",
  "common.holding-duration": "Holding Duration",
  "common.hours_one": "{{count}} hour",
  "common.hours_other": "{{count}} hours",
  "common.install": "Install",
  "common.installation": "Installation",
  "common.invalid_input": "Invalid input",
  "common.last_name": "Last name",
  "common.later": "Later",
  "common.less": "Less",
  "common.likes_one": "like",
  "common.likes_other": "likes",
  "common.liquidity": "Liquidity",
  "common.loading": "Loading",
  "common.loading-error": "Loading Error",
  "common.locally": "locally",
  "common.loss": "Loss",
  "common.max": "Max",
  "common.mcap-short": "MC",
  "common.mean": "Mean",
  "common.mentions_one": "mention",
  "common.mentions_other": "mentions",
  "common.min": "Min",
  "common.minutes": "Minutes",
  "common.mkt_cap": "MKT Cap",
  "common.more": "More",
  "common.more_info": "More info",
  "common.n_a": "N/A",
  "common.n-left": "{{n}} left",
  "common.name": "Name",
  "common.next": "Next",
  "common.no": "No",
  "common.no_data": "No data",
  "common.no-data-found": "No Data Found",
  "common.no-data-try-change-filters": "Try changing your filters or search query",
  "common.no-items": "No items",
  "common.no-items-found": "No items found",
  "common.no-recommendations": "No recommendations found",
  "common.no-results": "No results found",
  "common.no-results-found-for": "No results found for \"{{query}}\"",
  "common.not-a-single-match-was-found": "No matches found",
  "common.now": "Now",
  "common.of": "of",
  "common.open": "Open",
  "common.open_app": "Open App",
  "common.optional": "Optional",
  "common.or": "or",
  "common.page-not-found": "Page Not Found",
  "common.paste": "Paste",
  "common.paused": "Paused",
  "common.period.12h": "12h",
  "common.period.1d": "1d",
  "common.period.1h": "1h",
  "common.period.5m": "5m",
  "common.period.6h": "6h",
  "common.period.7d": "7d",
  "common.period.all": "All",
  "common.ping": "Ping",
  "common.pnl": "PnL",
  "common.pnl-total": "Total PnL",
  "common.position": "Position",
  "common.position-share": "Position %",
  "common.premium": "Premium",
  "common.price": "Price",
  "common.process": "Process",
  "common.processing": "Processing",
  "common.profile": "Profile",
  "common.profit": "Profit",
  "common.realized": "Realized",
  "common.reason": "Reason",
  "common.recent": "Recent",
  "common.refresh": "Refresh",
  "common.relaunch": "Relaunch",
  "common.reload": "Reload",
  "common.remove": "Remove",
  "common.report": "Report",
  "common.repository_one": "repository",
  "common.repository_other": "repositories",
  "common.retry": "Retry",
  "common.save": "Save",
  "common.saved": "Saved",
  "common.search": "Search",
  "common.searching": "Searching",
  "common.select-all": "Select All",
  "common.selected": "Selected",
  "common.send": "Send",
  "common.share": "Share",
  "common.sold": "Sold",
  "common.something_went_wrong_try_again": "Something went wrong. Please, try again later",
  "common.something-went-wrong": "Something went wrong",
  "common.sort": "Sort by",
  "common.status": "Status",
  "common.supply": "Supply",
  "common.symbol": "Symbol",
  "common.telegram": "Telegram",
  "common.theme": "Theme",
  "common.total": "Total",
  "common.total-invested": "Total Invested",
  "common.total-profit": "Total Profit",
  "common.total-sold": "Total Sold",
  "common.total-tokens-holding": "Total tokens",
  "common.trending-tokens-will-be-available-soon": "Trending tokens will be available soon",
  "common.try-again": "Try again",
  "common.try-changing-search-query": "Try to change your query",
  "common.twitter": "X",
  "common.tx_char": "TX",
  "common.txs": "TXs",
  "common.type": "Type",
  "common.unfollow": "Unfollow",
  "common.unfortunately": "Unfortunately",
  "common.unrealized-profit": "Unrealized Profit",
  "common.unselect-all": "Unselect All",
  "common.until": "until",
  "common.update": "Update",
  "common.updated_at": "Updated at",
  "common.upnl": "uPnL",
  "common.upnl-tooltip": "Unrealized Profit and Loss",
  "common.user_one": "User",
  "common.user_other": "Users",
  "common.user_reported_successfully": "User reported successfully",
  "common.username": "Username",
  "common.users": "Users",
  "common.version": "Version",
  "common.view_all": "View all",
  "common.volume": "Volume",
  "common.volume_char": "V",
  "common.volume_short": "Vol",
  "common.wallets": "Wallets",
  "common.website": "Website",
  "common.who_to_follow": "Who to follow",
  "common.win-rate": "Win Rate",
  "common.withdraw": "Withdraw",
  "common.yes": "Yes",
  "common.you": "You",
  "create-password": "Create Password",
  "currency.age-minutes": "Token Age (mins)",
  "currency.audit.caution": "Caution",
  "currency.audit.risky": "Risky",
  "currency.audit.safe": "Safe",
  "currency.create-cta": "Create a token",
  "currency.create-subtip": "When your token completes you will receive <0>0.5 SOL</0>",
  "currency.create-tip": "Token info cannot be changed after creation",
  "currency.create-token": "Create token",
  "currency.duplicates.reused-icons": "Reused Image Tokens",
  "currency.duplicates.see-more": "Go to the token page to see the full list",
  "currency.duplicates.similar-names": "Same Name Tokens",
  "currency.edit_the_token_details": "Edit the token details",
  "currency.edit_token": "Edit token",
  "currency.logo.restricted": "Restricted",
  "currency.logo.restricted-tooltip": "Token logo has not passed moderation",
  "currency.search_ticker_token_or_address": "Search by ticker, token name or contract address",
  "currency.search_token_or_address": "Search token or address",
  "currency.search-address": "Search address {{ticker}} on X",
  "currency.search-token": "Search token",
  "currency.select_currency": "Select Token",
  "currency.select-currency": "Select token",
  "currency.token_address_copied_message": "{{ticker}} token address copied to clipboard!",
  "currency.token_address_copy_tooltip": "Copy token address",
  "currency.token-address": "Token address",
  "currency.view_token_page": "View token page",
  "deep-link.download-dialog.continue-on-website": "Continue on website",
  "deep-link.download-dialog.download-app": "Download App",
  "deep-link.download-dialog.open-in-app": "Open in the App",
  "deep-link.download-dialog.title": "Download Desktop App",
  "deep-link.unsafe-url-dialog.description": "You are about to open a potentially dangerous link. Please be cautious and only proceed if you are sure about the source.",
  "deposit": "Deposit",
  "dev-tokens": "Dev Tokens",
  "dev-tokens.ath-mc": "ATH MC",
  "dev-tokens.dev": "DEV",
  "dev-tokens.highlights": "Highlights",
  "dev-tokens.last-token-launched": "Last Token Launched",
  "dev-tokens.migrated": "Migrated",
  "dev-tokens.no-tokens.description": "There is no more tokens created by the Dev",
  "dev-tokens.no-tokens.title": "No more launches",
  "dev-tokens.not-migrated": "Not migrated",
  "dev-tokens.token-stats": "Token Stats",
  "dev-tokens.total-pairs": "Total pairs",
  "error.auth.invalid-credentials": "Invalid credentials",
  "error.auth.invalid-otp": "Invalid OTP",
  "error.auth.invalid-token": "Invalid token",
  "error.auth.inviter-not-found": "Inviter not found",
  "error.auth.otp-required": "OTP required",
  "error.auth.unauthorized": "Unauthorized",
  "error.auth.user-already-exists": "User already exists",
  "error.auth.user-not-found": "User not found",
  "error.fastify.content-body-too-large": "Content body too large",
  "error.position.balance-not-found": "Balance not found {{amount}} {{ticker}} #id{{id}}",
  "error.position.bundle-missing-signatures": "Bundle missing signatures {{amount}} {{ticker}} #id{{id}}",
  "error.position.bundle-not-landed": "Bundle not landed {{amount}} {{ticker}} #id{{id}}",
  "error.position.bundle-wrong-transaction": "Bundle has wrong transaction {{amount}} {{ticker}} #id{{id}}",
  "error.position.dex-not-supported": "DEX is not supported {{amount}} {{ticker}} #id{{id}}",
  "error.position.insufficient-balance": "Insufficient balance {{amount}} {{ticker}} #id{{id}}",
  "error.position.insufficient-reserves": "Insufficient reserves {{amount}} {{ticker}} #id{{id}}",
  "error.position.pool-info-not-found": "Pool information not found {{amount}} {{ticker}} #id{{id}}",
  "error.position.swap-data-not-found": "Swap data not found {{amount}} {{ticker}} #id{{id}}",
  "error.position.swap-not-created": "Swap not created {{amount}} {{ticker}} #id{{id}}",
  "error.position.tips-account-not-found": "Tips account not found {{amount}} {{ticker}} #id{{id}}",
  "error.position.unsupported-provider": "Unsupported provider {{amount}} {{ticker}} #id{{id}}",
  "error.premium.expire-time-more-than-7-days": "Expire time more than 7 days",
  "error.premium.image-content-not-safe": "Image content not safe",
  "error.premium.image-safety-check-failed": "Image safety check failed",
  "error.premium.no-processing-boosters": "No processing boosters",
  "error.premium.not-enough-paid": "Not enough paid",
  "error.premium.premium-already-purchased": "Premium already purchased",
  "error.premium.premium-not-found": "Premium not found",
  "error.premium.transaction-not-found": "Transaction not found",
  "error.referral.referral-code-must-be-unique": "Referral code must be unique",
  "error.referral.this-referral-code-already-exists": "This referral code already exists",
  "error.secure-storage.already-exists-address": "This address already exists",
  "error.secure-storage.decryption-failed": "Failed to decrypt data",
  "error.secure-storage.desynced": "Local storage is out of sync with your saved keys. Please sign in again to restore access.",
  "error.secure-storage.internal-error": "An internal error has occurred",
  "error.secure-storage.invalid-deluge-id": "Invalid kol.trade ID",
  "error.secure-storage.invalid-encryption-key": "The encryption key is invalid.",
  "error.secure-storage.not-found": "Could not find the requested item",
  "error.secure-storage.sign-permit-error": "Failed to sign permit data",
  "error.secure-storage.storage-error": "A storage error has occurred",
  "error.secure-storage.storage-is-already-initialized": "Secure storage has already been set up.",
  "error.secure-storage.storage-is-locked": "Secure storage is currently locked.",
  "error.secure-storage.storage-is-unlocked": "Secure storage is currently unlocked.",
  "error.secure-storage.store-error": "Failed to store data",
  "error.secure-storage.unable-to-derive-key-from-password": "Failed to generate a key from the provided password.",
  "error.secure-storage.wrong-network": "Connected to the wrong network",
  "error.secure-storage.wrong-password": "The password you entered is incorrect.",
  "error.services.infura-not-responding": "Infura not responding",
  "error.services.not-enough-liquidity": "Not enough liquidity",
  "error.services.pair-not-found": "Pair not found",
  "error.services.pool-address-invalid": "Pool address invalid",
  "error.services.pool-fetch-failed": "Pool fetch failed",
  "error.services.pool-not-found": "Pool not found",
  "error.services.pools-fetch-failed": "Pools fetch failed",
  "error.services.position-not-found": "Position not found",
  "error.services.signature-required": "Signature required",
  "error.services.swap-not-found": "Swap not found",
  "error.services.token-address-invalid": "Token address invalid",
  "error.services.token-address-required": "Token address required",
  "error.services.token-not-found": "Token not found",
  "error.services.transaction-failed": "Transaction failed",
  "error.trade.allowance-not-fetched": "Allowance not fetched",
  "error.trade.approve-insufficient-funds": "Approve insufficient funds",
  "error.trade.create-swap-transaction": "Create swap transaction",
  "error.trade.database": "General database error",
  "error.trade.invalid-amount": "Invalid amount",
  "error.trade.no-active-position": "No active position",
  "error.trade.not-supported-provider": "Not supported provider",
  "error.trade.required-argument-missing": "Required argument missing",
  "error.trade.swap-insufficient-funds": "Swap insufficient funds",
  "error.trade.swap-order-not-found": "Swap order not found",
  "error.trade.transaction-missing": "Transaction missing",
  "error.trade.transaction-send": "Transaction send",
  "error.trade.unsupported-network": "Unsupported network",
  "error.user.otp-required": "OTP required",
  "error.wallet.asset-already-added": "Asset already added",
  "error.wallet.device-wallet": "That wallet is held on your device, so its key is only there",
  "error.wallet.invalid-private-key": "Not a valid private key",
  "error.wallet.no-route": "No way to make this trade was found",
  "error.wallet.router-unavailable": "Trading is not available right now",
  "error.wallet.keys-unavailable": "Wallets cannot be made here at the moment",
  "error.wallet.wallet-already-added": "Wallet already added",
  "error.wallet.wallet-not-found": "Wallet not found #id{{id}}",
  "error.wallet.wallet-sign-error": "Wallet sign error",
  "explore.ranked-by": "Ranked by",
  "explore.cooking": "Cooking",
  "explore.developer-swap-tooltip.buy": "Dev Bought",
  "explore.developer-swap-tooltip.sell": "Dev Sold",
  "explore.developer-swap-tooltip.sold-all": "Sold All",
  "explore.developer-tokens-tooltip.bonded": "Bonded",
  "explore.developer-tokens-tooltip.created": "Created",
  "explore.developer-tokens-tooltip.created-7d": "Created (7d)",
  "explore.developer-tokens-tooltip.top-tokens": "Top Tokens",
  "explore.developer-tokens.24h-traders": "24h traders",
  "explore.graduated": "Graduated",
  "explore.sort.created-at": "Created",
  "explore.sort.gain-score": "Gain Score",
  "explore.sort.holders-change-percent": "Holders Change",
  "explore.sort.holders-count": "Holders",
  "explore.sort.tx-count": "Tx",
  "explore.trending-gainers": "Top Gainers",
  "explore.trending-tokens": "Trending",
  "fun.created-by": "Created By",
  "fun.explore.create-token": "Create Token",
  "fun.explore.description": "Create your own coins, sell them on our platform and create capital.",
  "fun.explore.title": "Deluge.fun",
  "fun.find_best": "find the best tokens that already exist.",
  "fun.launched_time": "Launched time",
  "fun.listed_on_deluge": "Listed on Deluge",
  "fun.search_placeholder": "Enter ticker, token name or contract address",
  "fun.ticker": "Ticker",
  "fun.top_tokens_title": "Top tokens on Deluge.fun",
  "gas-settings": "Gas Settings",
  "gas-settings.base-fee": "Base fee",
  "gas-settings.change-gas-settings": "Change gas settings",
  "gas-settings.congestion.high": "Busy",
  "gas-settings.congestion.low": "Low",
  "gas-settings.congestion.stable": "Stable",
  "gas-settings.estimated-fee": "Estimated fee",
  "gas-settings.gas-cost": "gas cost",
  "gas-settings.gas-option": "Gas option",
  "gas-settings.help-line-1": "Would you like to",
  "gas-settings.help-line-2": "about gas?",
  "gas-settings.help-line-link": "know more",
  "gas-settings.max-fee": "Max fee",
  "gas-settings.network-status": "Network Status",
  "gas-settings.option.advanced": "Advanced",
  "gas-settings.option.high": "Aggressive",
  "gas-settings.option.low": "Slow",
  "gas-settings.option.market": "Market",
  "gas-settings.priority-fee": "Priority fee",
  "gas-settings.time": "Time",
  "gas-settings.tooltip-description.advanced": "Use <b>{{label}}</b> to customize the gas price. This can be confusing if you aren't familiar. Interact at your own risk.",
  "gas-settings.tooltip-description.high": "High probability, even in volatile markets. Use <b>{{label}}</b> to cover surges in network traffic due to things like popular NFT drops.",
  "gas-settings.tooltip-description.low": "Use <b>{{label}}</b> to wait for a cheaper price. Time estimates are much less accurate as prices are somewhat unpredictable.",
  "gas-settings.tooltip-description.market": "Use <b>{{label}}</b> for fast processing at current market price.",
  "gas-settings.variant.advanced": "Advanced",
  "gas-settings.variant.high": "Aggressive",
  "gas-settings.variant.low": "Slow",
  "gas-settings.variant.market": "Market",
  "holder_other": "Holders",
  "initial.loading_error": "Loading Error",
  "insider_one": "Insider",
  "insider_other": "Insiders",
  "insiders": "Insiders",
  "instant-trade.swap-buttons.saved": "Instant trade buttons were saved successfully",
  "language": "Language",
  "language.bg": "Bulgarian",
  "language.bs": "Bosnian",
  "language.cs": "Czech",
  "language.da": "Danish",
  "language.de": "German",
  "language.el": "Greek",
  "language.en": "English",
  "language.es": "Spanish",
  "language.et": "Estonian",
  "language.fi": "Finnish",
  "language.fr": "French",
  "language.hr": "Croatian",
  "language.hu": "Hungarian",
  "language.it": "Italian",
  "language.lt": "Lithuanian",
  "language.lv": "Latvian",
  "language.mk": "Macedonian",
  "language.nl": "Dutch",
  "language.no": "Norwegian",
  "language.pl": "Polish",
  "language.pt": "Portuguese",
  "language.ro": "Romanian",
  "language.ru": "Russian",
  "language.sk": "Slovak",
  "language.sl": "Slovenian",
  "language.sq": "Albanian",
  "language.sr": "Serbian",
  "language.sv": "Swedish",
  "language.tr": "Turkish",
  "language.uk": "Ukrainian",
  "latency.average": "Average",
  "latency.bad": "Bad",
  "latency.connected": "Connected",
  "latency.disconnected": "Disconnected",
  "latency.disconnected.description": "The connection to the server has been lost.",
  "latency.good": "Good",
  "leaderboard.dont_have_rank": "You don't have a rank yet",
  "leaderboard.place": "place",
  "leaderboard.user_names": "User names",
  "leaderboard.you_are_in": "You are in",
  "limit_order.status_active": "Active",
  "limit_order.status_cancelled": "Cancelled",
  "limit_order.status_completed": "Completed",
  "limit_order.status_expired": "Expired",
  "limit_order.status_failed": "Failed",
  "maker_one": "Maker",
  "maker.30d-win-rate": "30D Win Rate",
  "maker.size.description.dolphin": "Dolphin: $1k-$10k traded",
  "maker.size.description.fish": "Fish: <$250 traded",
  "maker.size.description.shrimp": "Shrimp: $250-$1k traded",
  "maker.size.description.whale": "Whale: $10k+ traded",
  "maker.size.dolphin": "Dolphin",
  "maker.size.fish": "Fish",
  "maker.size.shrimp": "Shrimp",
  "maker.size.whale": "Whale",
  "maker.tag.bundler.tooltip": "Bundler",
  "maker.tag.fresh.tooltip": "Fresh wallet",
  "maker.tag.insider.tooltip": "Insider",
  "maker.tag.sniper.tooltip": "Sniper",
  "maker.volume-tooltip": "{{amount}} traded",
  "market-cap": "Market Cap",
  "mfa.code_copied_message": "Code copied!",
  "mfa.copy_key": "Copy key",
  "mfa.instruction_line_1": "Download the authentication app.<0/> <1>We recommend downloading Duo Mobile or Google Authenticator</1>, if you don't have any of these applications installed.",
  "mfa.instruction_line_2": "Add the code in the authentication app or scan the QR code.",
  "mfa.instruction_line_3": "Once the authentication app generates a code, please enter it on the next screen",
  "mfa.mfa_successfully_set_message": "Second factor device was successfully set!",
  "mfa.mfa-removed.message": "Multi-Factor Authentication has been disabled",
  "mfa.qr_core": "QR Code",
  "mfa.remove-mfa-confirm-message": "Disabling multi-factor authentication will remove an extra layer of security from your account. This means you will no longer need to enter a verification code during suspicious login attempts. We recommend keeping MFA enabled for enhanced protection. Do you wish to proceed?",
  "mfa.remove-mfa-title": "Disable Multi-Factor Authentication",
  "mfa.setup_authenticator_note": "Open your authenticator app and choose the option to scan a QR code. Then, use the 6-digit code to finish the setup.",
  "mfa.setup_instructions": "Setup Instructions",
  "mfa.two_factory_auth": "Two-factor authentication",
  "navigation.favorite": "Watchlist",
  "navigation.login": "Login",
  "navigation.portfolio": "Portfolio",
  "navigation.wallet-tracker": "Tracker",
  "network-data.priority-fee-tooltip": "Priority Fee: {{amount}} {{ticker}}",
  "new-pairs": "New Pairs",
  "nft.collection.all": "All",
  "nft.collection.apply-changes": "Apply Changes",
  "nft.collection.collection-preview": "Collection preview",
  "nft.collection.default-description": "Describe your collection here. Add more details to help users and marketplaces understand what makes this collection unique and interesting.",
  "nft.collection.default-name": "My NFT Collection",
  "nft.collection.grid-size": "Grid size",
  "nft.collection.item-details": "Item details",
  "nft.collection.layer-name": "Layer name",
  "nft.collection.randomize": "Randomize",
  "nft.collection.select-properties-to-edit": "Select properties to edit:",
  "nft.collection.select-trait": "Select trait",
  "nft.collection.used-in-items": "Used in {{count}} items {{rarity}}%",
  "nft.edit.collection": "Collection",
  "nft.edit.properties": "Properties",
  "nft.group.accessories": "Accessories",
  "nft.group.background": "Background",
  "nft.group.body": "Body",
  "nft.group.eyes": "Eyes",
  "nft.group.face": "Face",
  "nft.group.hair": "Hair",
  "nft.groups.create-group": "Create group",
  "nft.groups.create-new": "Create New",
  "nft.groups.default-name-prefix": "Group",
  "nft.groups.enter-name": "Enter name",
  "nft.library.add-rule": "Add rule",
  "nft.library.all-images": "All Images",
  "nft.library.all-traits": "All traits",
  "nft.library.delete-all": "Delete all",
  "nft.library.delete-group": "Delete group",
  "nft.library.delete-trait": "Delete trait",
  "nft.library.empty.subtitle": "unique NFT collection for sale",
  "nft.library.empty.title": "Start creating your own",
  "nft.library.notes.first-author": "Every first author receives about $1,000<0>from the sale of his collection.</0>",
  "nft.library.notes.second-author": "Every second author receives about $2,000<0>from the sale of his collection.</0>",
  "nft.library.notes.third-author": "Every third author receives about $3,000<0>from the sale of his collection.</0>",
  "nft.library.rules-description": "A rule allows you to block or force certain traits to match together. If you have too many rules, consider using the advanced mode instead.",
  "nft.library.sort-by": "Sort by",
  "nft.library.trait-name": "Trait name",
  "nft.library.trait-search-placeholder": "Search trait",
  "nft.library.usage": "Usage",
  "nft.messages.all-cleared": "All groups, traits, and rules have been cleared. Your NFT project is now reset.",
  "nft.messages.collection-published": "Your collection has been successfully published to the marketplace.",
  "nft.messages.group-created": "Group created",
  "nft.messages.group-deleted": "Group deleted",
  "nft.messages.image-removed": "Image removed",
  "nft.messages.rules-cleared": "Rules cleared",
  "nft.messages.trait-already-exists": "Trait already exists",
  "nft.messages.trait-removed": "Trait removed",
  "nft.nav.groups": "Groups",
  "nft.navigation.edits": "Edits",
  "nft.navigation.generate": "Generate",
  "nft.navigation.library": "Library",
  "nft.navigation.publish": "Publish",
  "nft.processing.cancel": "Cancel",
  "nft.processing.creating-collection": "Creating your Collection",
  "nft.publish.choose-collection-avatar": "Choose collection avatar",
  "nft.publish.preview-on-marketplace": "Preview on marketplace",
  "nft.publish.publish-collection": "Publish collection",
  "nft.rarity.default": "Default",
  "nft.rarity.label-rare": "Rare 16-25%",
  "nft.rarity.label-rarest": "The rarest 6-15%",
  "nft.rarity.label-regular": "Regular",
  "nft.rarity.label-unique": "Unique 1-5%",
  "nft.rarity.ordinary": "ordinary",
  "nft.rarity.rarity": "Rarity",
  "nft.rarity.short": "R:",
  "nft.settings.clear-all": "Clear all",
  "nft.settings.description": "Description",
  "nft.settings.height": "Height",
  "nft.settings.how-it-works": "How it works?",
  "nft.settings.name": "Name",
  "nft.settings.reset-to-default": "Reset to default",
  "nft.settings.save": "Save",
  "nft.settings.size": "Size",
  "nft.settings.title": "Settings",
  "nft.settings.width": "Width",
  "nft.single-image-tab.added": "Added",
  "nft.single-image-tab.rules": "Rules",
  "nft.sort-by.date": "Date",
  "nft.sort-by.name": "Name",
  "nft.sort-by.rarity": "Rarity",
  "nft.start-tab.images": "Images",
  "nft.start-tab.rarity-settings": "Rarity settings",
  "nft.upload.open-to-upload": "Open to upload new files",
  "nft.upload.open-to-upload-expanded": "<0>Click or drop images here!</0>png, max file size: 2MB per image",
  "notification-center.active_wallets_one": "{{count}} active wallet",
  "notification-center.active_wallets_other": "{{count}} active wallets",
  "notification-center.additional_widgets_view": "View of shared widgets",
  "notification-center.last_transactions": "Last Transactions",
  "notification-center.my_profile": "My profile",
  "notification-center.notifications": "Notifications",
  "notification-center.personal_widgets": "Personal Widgets",
  "notification-center.reorder_widget": "Reorder widget",
  "notification-center.save_changes": "Save changes",
  "notification-center.set_widgets": "Set Widgets",
  "notification-center.shared_widgets": "Shared Widgets",
  "notification-center.updates_one": "{{count}} update",
  "notification-center.updates_other": "{{count}} updates",
  "notification-center.widgets_settings_changed": "Widgets settings changed",
  "onboarding-dialog.boosting-terms": "Boosting Terms",
  "onboarding-dialog.confirm": "I confirm and agree",
  "onboarding-dialog.description": "You can launch and trade tokens here.<0/>By continuing, <1>you confirm that you are 18+ and accept our Terms of Service.</1>",
  "onboarding-dialog.disclaimer": "Disclaimer",
  "onboarding-dialog.privacy-policy": "Privacy policy",
  "onboarding-dialog.terms-of-service": "Terms of service",
  "onboarding-dialog.title": "Create & Trade!",
  "onboarding-dialog.welcome": "Welcome!",
  "onboarding.story-viewer-aria-label": "Story Viewer",
  "order_other": "Orders",
  "order.active-order_one": "Active order",
  "order.active-order_other": "Active orders",
  "order.all-orders": "All orders",
  "order.cancel-all": "Cancel all",
  "order.cancel-all-confirm.description": "Are you sure you want to cancel all active orders?",
  "order.cancel-all-confirm.title": "Cancel all orders",
  "order.close-order-completed": "Order has been closed",
  "order.close-order-confirm-description": "By closing this limit order, it will no longer execute when the target conditions are met. If you still want to trade at a specific price, you will need to create a new limit order. Please confirm to proceed.",
  "order.close-order-confirm-title": "Are you sure you want to close the limit order?",
  "order.creation-date": "Creation date",
  "order.edit-completed": "Order has been successfully changed!",
  "order.edit-fee-alert": "Please note that making changes to your limit order will result in a network fee of <n />",
  "order.edit-order": "Edit order",
  "order.expiry": "Expiry",
  "order.limit-buy-tooltip": "Buy when {{target}} is equal or below {{currency}}{{price}}",
  "order.limit-sell-tooltip": "Sell when {{target}} is below {{currency}}{{stopLoss}} or above {{currency}}{{takeProfit}}",
  "order.status.active": "Active",
  "order.status.failed": "Failed",
  "order.table.avg-exec": "Avg Exec",
  "order.table.order-amt": "Order Amt",
  "order.table.side": "Side",
  "order.trigger-condition": "Trigger Condition",
  "orders.cancel-all": "Cancel all",
  "orders.empty": "Nothing waiting",
  "orders.page.active-tokens-orders": "Active tokens orders",
  "orders.page.description": "Manage limit and advanced orders",
  "orders.trigger.market-cap": "MC",
  "orders.trigger.price": "Price",
  "orders.page.title": "Orders",
  "otp.modal.error": "Invalid OTP code",
  "otp.modal.subtitle": "For your security please enter OTP code from authenticator app",
  "otp.modal.title": "Verify your identity",
  "pair-activity.boost-purchased": "<0>{{count}} boosters</0> purchased",
  "pair-activity.premium-purchased": "purchased",
  "pair.cashback-mode.tooltip": "Creator fees are returned to traders, not creators",
  "pair.fees": "Fees",
  "pair.fees.bundle-fees": "Bundle fees",
  "pair.fees.gas-fees": "Gas fees",
  "pair.fees.pool-fee": "Pool fee",
  "pair.fees.priority-fees": "Priority fees",
  "pair.filter.pair-age": "Pair age (mins)",
  "pair.filter.socials": "Socials",
  "pair.migrated": "Migrated",
  "pair.pair-address": "Pair address",
  "pair.pair-not-found": "Pair not found",
  "pair.pair-not-found.description": "The pair you are looking for is unavailable, or the link is broken",
  "pair.token-migrated-tooltip": "Token has been graduated at {{timestamp}}",
  "pair.tokenized-agent.tooltip": "Tokenized agent",
  "password": "Password",
  "platform.all_platforms": "All platforms",
  "platform.deluge_apps": "kol.trade Apps",
  "policies.affiliate-program-terms": "Affiliate Program Terms",
  "policies.anti-money-laundering-policy": "Anti-Money Laundering Policy (AML)",
  "policies.boosting-terms": "Boosting Terms",
  "policies.disclaimer-terms": "Disclaimer",
  "policies.legal-entity-access-terms": "Law Enforcement Requests",
  "policies.live-streaming-terms": "Live streaming Terms",
  "policies.privacy-policy": "Privacy Policy",
  "policies.terms-of-service": "Terms of Service",
  "policies.token-creation-and-promotion-terms": "Token Creation & Promotion Terms",
  "pool": "Pool",
  "pool.currency-ca": "Token CA",
  "pool.currency-price": "Token Price",
  "pool.liquidity": "Liquidity",
  "pool.liquidity-char": "L",
  "pool.liquidity-pool": "Liquidity Pool",
  "pool.mcap": "MCAP",
  "pool.mcap_char": "M",
  "pool.open-in-explorer": "Open in {{provider}}",
  "pool.pair-ca": "Pair CA",
  "pool.select-pool": "Select Pool",
  "portfolio.active-positions.title": "Active positions",
  "portfolio.hidden-positions": "Hidden positions",
  "portfolio.page.title": "Portfolio Analyzer",
  "portfolio.pnl-chart.calendar-next-month": "Next month",
  "portfolio.pnl-chart.calendar-prev-month": "Previous month",
  "portfolio.pnl-chart.chart-view": "Chart view",
  "portfolio.pnl-chart.error-description": "Your stats will appear after you open your first position",
  "portfolio.pnl-chart.error-description.another-user": "Trading stats of this user will appear after they open their first position",
  "portfolio.pnl-chart.error-title": "Your trading stats will be shown here",
  "portfolio.pnl-chart.error-title.another-user": "Trading stats of this user will be shown here",
  "portfolio.pnl-chart.title": "Realized PnL",
  "portfolio.pnl-chart.view-calendar": "Calendar view",
  "portfolio.trade-history": "Trade history",
  "portfolio.trading-distribution.loss": "Under 0%",
  "portfolio.trading-distribution.profit-over-200": "Over 200%",
  "portfolio.trading-distribution.profit-under-200": "0 - 200%",
  "portfolio.trading-distribution.title": "Distribution",
  "position_one": "Position",
  "position_other": "Positions",
  "position.all-positions": "All positions",
  "position.bought": "Bought",
  "position.close-position": "Close position",
  "position.close-position-confirm-description": "By closing this position, you will sell all the tokens associated with it at the current market rate.",
  "position.close-position-confirm-title": "Are you sure you want to close the position?",
  "position.closed": "closed",
  "position.entry-price": "Entry price",
  "position.hide-position.tooltip": "Hide position",
  "position.invest": "Invest",
  "position.invest-short": "Inv.",
  "position.position-closed-all-message": "All {{ticker}} positions have been closed",
  "position.position-details": "Position details",
  "position.remaining": "Remaining",
  "position.remaining-short": "Rem.",
  "position.sold": "Sold",
  "position.sold-short": "Sold",
  "position.table.visibility": "Visibility",
  "position.target-price": "Target price",
  "position.unhide-position.tooltip": "Unhide position",
  "position.wallet-position-modal.title": "{{ticker}} positions by wallet",
  "premium.archived-label": "Archived",
  "premium.archived-list.archive": "Archive",
  "premium.archived-list.current": "Current",
  "premium.archived-list.date": "Date",
  "premium.archived-list.owner": "Owner",
  "premium.archived-list.title": "Archived list",
  "premium.boosters": "Boosters",
  "premium.button.boost": "Boost",
  "premium.button.buy-again": "Buy again",
  "premium.button.buy-boosters": "Buy Boosters",
  "premium.button.buy-subscription": "Buy Premium",
  "premium.button.pay-amount": "Pay",
  "premium.button.renew": "Renew",
  "premium.button.renew-premium": "Renew Premium",
  "premium.carousel.empty.sub-title": "Your premium tokens will be displayed here",
  "premium.carousel.empty.title": "You have no premium tokens!",
  "premium.carousel.title": "Other tokens with a Premium",
  "premium.check.alert.active": "This token already has a premium subscription",
  "premium.check.alert.failed": "Token hasn't passed safety checks",
  "premium.check.alert.passed": "Token has passed safety checks",
  "premium.check.currency.supply": "Supply: {{supply}} {{ticker}}",
  "premium.check.message.unknown-error": "Unable to check token",
  "premium.check.note.active": "You can buy boosters for this token!",
  "premium.check.note.failed": "Check Another Token",
  "premium.check.note.passed": "You are able to purchase <0>Premium</0> subscription!",
  "premium.check.result": "Token verification result",
  "premium.currency.emoji": "Trending emoji",
  "premium.currency.sub-title": "which you added to the tokens",
  "premium.currency.title": "Your Tokens",
  "premium.extend.title": "Extend <0>Premium</0>",
  "premium.feed": "Premium Feed",
  "premium.feed.buy-premium": "Buy Premium",
  "premium.feed.purchased-item": "Purchase",
  "premium.form.invalid-url-telegram": "Invalid Telegram URL",
  "premium.form.invalid-url-website": "Invalid Website URL",
  "premium.form.invalid-url-x": "Invalid X URL",
  "premium.image-upload.loading-description": "Your image is uploading",
  "premium.image-upload.loading-title": "Wait a minute...",
  "premium.image-upload.size": "the image size should be {{size}}",
  "premium.info.button.check-token": "Check Token",
  "premium.info.sub-title": "Each token that passes safety checks has the opportunity to buy a Premium subscription.",
  "premium.info.text.cost": "A subscription is issued upon purchasing {{boosts}} boosts and is valid for 30 days if the token does not already have one.",
  "premium.info.text.how-to-buy": "in the <0>TMA application</0> via a special link or button in the bot or in a message",
  "premium.info.text.requirements": "the token must pass safety Check",
  "premium.info.text.validity": "30 days. It can be extended for another 30 days when less than 7 days remain.",
  "premium.info.text.what-it-gives": "Abilty to buy Splash Point Boosters if token passes safety checks <0/> Changing the logo in the application <0/> Adding a banner to the token page <0 /> Adding social links to the token page",
  "premium.info.title.cost": "Cost",
  "premium.info.title.how-to-buy": "How to buy",
  "premium.info.title.requirements": "Requirements",
  "premium.info.title.validity": "Validity period",
  "premium.info.title.what-it-gives": "What it gives",
  "premium.not-eligible-snackbar.description": "Premium for this token has been purchased by someone else. You cannot customize this token.",
  "premium.not-eligible-snackbar.title": "Unable to customize",
  "premium.owned-by": "Owned by",
  "premium.pay.boosters.note": "Splash Point Boosters work 24 hours and then burn out. You can purchase any number of boosts",
  "premium.pay.boosters.success": "You can buy <0>Boosters</0> for any token that passes the safety check",
  "premium.pay.boosters.title": "Buy Splash Point <0>Boosters</0>",
  "premium.pay.check-tx": "Check transaction hash",
  "premium.pay.error-ballance": "Insufficient Balance",
  "premium.pay.extend-error": "Unable to extend Premium",
  "premium.pay.no-wallet": "Select wallet",
  "premium.pay.not-enough-boosters-for-premium": "Minimum {{boosters}} boosters",
  "premium.pay.portal-link.info-text": "Add a link to your telegram that will lead to your token and help other users find it. You need to add a link to the direct telegram",
  "premium.pay.portal-link.invalid": "Invalid portal link",
  "premium.pay.portal-link.title": "Telegram Link",
  "premium.pay.safety-check.check-btn": "Check token safety",
  "premium.pay.safety-check.description": "In order to buy boosters, a <0>Premium</0> must be connected to the token. To do this, check the token",
  "premium.pay.subscription.link": "Enter your Telegram portal link",
  "premium.pay.subscription.link-placeholder": "https://t.me/portallink",
  "premium.pay.subscription.note": "A subscription is issued upon purchasing {{boosts}} boosts and is valid for 30 days if the token does not already have one.  The subscription is also extended upon purchasing {{extendBoosts}} boosts if it expires in less than 7 days.",
  "premium.pay.subscription.success": "You can <0>buy a Premium</0> for any token that passes the safety check",
  "premium.pay.subscription.title": "Buy <0>Premium</0>",
  "premium.pay.wallets.title": "Choose a payment method",
  "premium.product.booster-text": "The booster costs {{price}} SOL and lasts 24 hours",
  "premium.product.booster-title": "Splash Point <0>Booster</0>",
  "premium.product.premium-text": "A subscription is issued upon purchasing {{boosts}} boosts and is valid for 30 days if the token does not already have one",
  "premium.product.premium-title": "<0>Premium</0> Subscription",
  "premium.purchase.invoice": "Invoice",
  "premium.purchase.status.failed": "Failed",
  "premium.purchase.status.processing": "Processing",
  "premium.purchase.status.success": "Success",
  "premium.purchased.date-due": "<0>Premium</0> until {{date}}",
  "premium.purchased.date-ended": "ended on {{date}}",
  "premium.purchased.empty-description": "Promote your token to reach more traders",
  "premium.purchased.empty-title": "Boost visibility with Premium",
  "premium.purchased.sub-title": "which you added to the tokens",
  "premium.purchased.tab.active": "Active Premiums",
  "premium.purchased.tab.inactive": "Expired Premiums",
  "premium.purchased.tab.purchase-history": "Purchase History",
  "premium.purchased.title": "Your Tokens",
  "premium.purchased.title-long": "Your Premium Subscription",
  "premium.purchased.until": "until {{date}}",
  "premium.search.error.currency-not-found": "Token not found",
  "premium.search.subtitle": "Already have Premium?",
  "premium.search.subtitle-check-token": "Check the token before buying a premium",
  "premium.search.title": "Enter the token address",
  "premium.slider.slide-banner": "The ability to set a custom banner in the trending list and custom emoji",
  "premium.slider.slide-color": "To highlight the token ticker with a color based on SP rank",
  "premium.slider.slide-logo": "To change the logo in the app",
  "premium.slider.slide-raid": "<0>Up to 3 simultaneous raids</0><br />Without subscription, only 1 raid",
  "premium.slider.slide-splash": "To buy Splash Point boosters if token passes safety checks",
  "premium.slider.title": "What does <0>Premium</0> offer for tokens?",
  "premium.splash-points": "Splash Points",
  "premium.title": "Premium",
  "premium.update-emoji.change-image": "Change image",
  "premium.update-emoji.choose-image": "Choose image",
  "premium.update-emoji.preview": "Preview example",
  "premium.update-emoji.title": "Set up your trending emoji",
  "premium.update-links.updated": "Social links have been successfully updated.",
  "premium.update-logo.error.retry": "Try another image",
  "premium.update-logo.error.support": "Write to support",
  "premium.update-logo.image-safety-heck-failed": "The image did not pass verification.",
  "premium.update-logo.preview": "Usage example",
  "premium.update-logo.processing": "Wait a minute... <0>Your image is uploading</0>",
  "premium.update-logo.success": "Success! <0>Your logo is processing</0>",
  "premium.update-logo.title": "Choose an image",
  "price": "Price",
  "profile.all_past_purchases": "All past purchases",
  "profile.analysis.analysis": "Analysis",
  "profile.analysis.avg-cost": "Avg Cost",
  "profile.analysis.avg-duration": "Avg Duration",
  "profile.analysis.avg-realized-profits": "Avg Realized Profits",
  "profile.analysis.avg-sold": "Avg Sold",
  "profile.analysis.fees": "Fees",
  "profile.analysis.fees-tooltip": "Total transaction fees paid",
  "profile.analysis.renamed": "Renamed",
  "profile.analysis.tracked": "Tracked",
  "profile.analysis.txs": "TXs",
  "profile.analysis.volume-tooltip": "Total trading volume",
  "profile.avg_buy_mc_distribution": "Avg Buy MC Distribution",
  "profile.avg_buy_mc_distribution.above_500k": "> $500k",
  "profile.avg_buy_mc_distribution.below_100k": "$0 - $100k",
  "profile.avg_buy_mc_distribution.from_100k_to_500k": "$100k - $500k",
  "profile.best_deal": "The best deal",
  "profile.best_deal_title": "The Best Deal",
  "profile.best_deal.close_price": "Close price",
  "profile.best_deal.download_error": "Error during file download",
  "profile.best_deal.download_success": "File successfully downloaded",
  "profile.best_deal.entry_price": "Entry price",
  "profile.best_deal.share_result": "Share result",
  "profile.best_deal.title": "Your best deal",
  "profile.buy_d_premium": "Buy Premium",
  "profile.connections.followers-other.empty-description": "This given profile doesn't have any followers yet, trades will appear here after a user starts trading.",
  "profile.connections.followers-other.empty-title": "The user doesn't have any followers yet",
  "profile.connections.followers.empty-description": "You don't have any subscribers, start actively trading and attract attention to your profile.",
  "profile.connections.followers.empty-title": "You don't have any followers",
  "profile.connections.followings.empty-description": "Find interesting users, follow their trades and transactions.",
  "profile.connections.followings.empty-title": "Find new users and monitor their transactions",
  "profile.distribute-drawer.token-distribution": "Token Distribution",
  "profile.distribution": "Distribution",
  "profile.edit_profile": "Edit profile",
  "profile.edit.change-avatar.only-hyped-tooltip": "You need to have Hyped status to set avatar",
  "profile.leaderboard": "Leaderboard",
  "profile.phishing-check.danger": "danger",
  "profile.phishing-check.normal": "clear",
  "profile.phishing-check.warning": "warning",
  "profile.positions-active": "Active Positions",
  "profile.profile_avatar_updated": "Profile avatar has been updated",
  "profile.profile_info_updated": "Profile info has been updated",
  "profile.profit": "Profit",
  "profile.social.past-handles": "Past handles",
  "profile.social.twitter-stats.favoritesCount": "Number of liked posts",
  "profile.social.twitter-stats.followersCount": "Number of followers",
  "profile.social.twitter-stats.followingCount": "Number of accounts followed",
  "profile.social.twitter-stats.mediaCount": "Number of media posts",
  "profile.statistics": "Statistics",
  "profile.statistics.buy_premium": "<0>Buy</0> <1>Premium</1> for a token",
  "profile.statistics.tab-distribution": "Distribution",
  "profile.statistics.tab-phishing": "Phishing",
  "profile.statistics.tab-profit": "Profit",
  "profile.statistics.tabs.deployed-tokens": "Deployed Tokens",
  "profile.statistics.tabs.holdings": "Holdings",
  "profile.statistics.tabs.trades": "Trades",
  "profile.statistics.trading_leaderboard": "Trading Leaderboard",
  "profile.trading_summary": "Trading Summary",
  "profile.transaction_history": "Transaction history",
  "profile.user-trading-analytics.blacklist": "Blacklist",
  "profile.user-trading-analytics.block-title": "Phishing check",
  "profile.user-trading-analytics.didnt-buy": "Didn't buy",
  "profile.user-trading-analytics.fast-flip": "Buy/Sell in 5s",
  "profile.user-trading-analytics.sold-more-than-bought": "Sold > Bought",
  "profile.welcome.buy_premium": "<0>Buy Premium</0> for a token to get",
  "profile.welcome.no_active_premium_tokens": "You don't have any active Premium tokens",
  "profile.welcome.past_purchases": "Your past purchases",
  "protocol": "Protocol",
  "protocol_many": "Protocols",
  "provider": "Provider",
  "referral": "Referral",
  "referral.add-invite-code": "Add invite code",
  "referral.add-invite-code-description": "You are going to get the code from:",
  "referral.add-referral-code": "Add referral code",
  "referral.bring_out": "Withdraw",
  "referral.change-invite-code": "Change invite code",
  "referral.change-referral-code": "Change referral code",
  "referral.change-referral-note": "You only need to pay the gas fee to rename it",
  "referral.code_copied_message": "Referral code has been copied!",
  "referral.code-info.current-code-label": "current code:",
  "referral.create_referral_code": "Create referral code",
  "referral.create-price-title": "Creating a referral code cost",
  "referral.create-subtitle": "You can get <0>a lot of bonuses from other users</0> through your <1>referral code</1>:",
  "referral.create-title": "Invite Your First Referral!",
  "referral.current-code-user-label": "current code and user:",
  "referral.earnings": "Earn from referral",
  "referral.enter_referral_code": "Enter referral code",
  "referral.enter_unique_code": "Enter unique code",
  "referral.invite": "Invite",
  "referral.invite_referral": "Invite a referral",
  "referral.invite-code": "Invite code",
  "referral.invite-code-form.note": "This code is valid only on the <0>{{network}}</0> blockchain",
  "referral.invite-code.current-code": "current code",
  "referral.invite-code.empty-description": "You don’t have any current referral code from another user yet",
  "referral.invite-referral-description": "You can get additional bonuses from referral transactions.",
  "referral.leaderboard": "Referral Leaderboard",
  "referral.network-referral-code": "{{network}} Ref. Code",
  "referral.new_referral_code_description": "Enter the referral code to connect it",
  "referral.new_referral_code_has_been_successfully_created": "New referral code has been successfully added",
  "referral.new-code-user-label": "new code and user:",
  "referral.no-link-placeholder": "In order to receive your referral link, you need to contact technical support",
  "referral.point1": "Get <0>0.05% bonus</0> on each swap of your referral",
  "referral.point2": "<0>Discounts</0> on your own transactions <0>up to 80%</0>",
  "referral.point3": "Personal <0>bonuses</0> every trading period",
  "referral.points-info.label": "Your bonuses from referral:",
  "referral.referral_code": "Referral code",
  "referral.referral_code_has_been_successfully_changed": "Referral code has been successfully changed",
  "referral.referral_code_has_been_successfully_set": "Referral code has been successfully set.",
  "referral.referral_users": "Referral Users",
  "referral.referral-code-form.note": "You create a referral code on the <0>{{network}}</0> blockchain",
  "referral.share-text": "Use my referral link to join me on kol.trade — the crypto trading bot you can trust!",
  "referral.try-another-code": "Try with another code",
  "referral.update_referral_code": "Update referral code",
  "referral.users-referred": "users referred",
  "referral.view-referral-subtitle": "Now you can share it and get all bonuses from the platform",
  "referral.withdraw.bring_out": "Withdraw",
  "referral.withdraw.processing.title": "Transaction in process",
  "referral.withdraw.select_wallet": "Select a wallet for withdraw",
  "referral.withdraw.send-to": "Send to",
  "referral.withdraw.transaction-in-process": "Transaction in process",
  "referral.withdraw.transaction-in-process-message": "The transaction could not be completed due to network congestion or insufficient liquidity.",
  "referral.withdraw.your-referral-balance": "Your referral balance",
  "referral.your_referrals": "Your Referrals",
  "referral.your-referral-code": "Your referral code",
  "report.report-telegram-group-description": "Please provide a reason and any additional information for reporting this group",
  "report.report-telegram-group-success": "Telegram group has been reported",
  "scan.camera-permission-denied": "Camera permission denied",
  "scan.camera-permission-denied-description": "Please enable camera permission in settings",
  "scan.invalid-address": "Invalid wallet address",
  "scan.scan-qr-code": "Scan QR Code",
  "scan.scan-qr-code-description": "Place the QR code in the scanning frame",
  "scan.unable-to-scan-qr-code": "Unable to scan QR code",
  "search.no-recent-searches": "No recent searches",
  "search.recents": "Recents",
  "search.search-by-firstname-lastname-username": "Search by first name, last name, or username",
  "seed-phrase": "Seed Phrase",
  "session.delete-confirmation": "Do you really want to delete this session?",
  "session.delete-session": "Delete session",
  "session.delete-session-error": "Unable to delete session",
  "session.delete-session-success": "Session was successfully removed",
  "sessions": "Sessions",
  "sessions.browser": "browser",
  "sessions.ip_address": "IP address",
  "sessions.last_session": "last session",
  "sessions.os": "OS",
  "sessions.this_device": "This device",
  "settings": "Settings",
  "settings.about-the-app": "About the app",
  "settings.account-and-privacy": "Account and privacy",
  "settings.active_sessions": "Active sessions",
  "settings.app-settings": "App settings",
  "settings.app-settings.interface-size": "Interface size",
  "settings.app-settings.is-flash-distinct-enabled": "Show flash distinct animations",
  "settings.app-settings.show-pair-activity-notifications": "Show activity notifications",
  "settings.app-settings.show-pair-audit-alert": "Show pair audit alert",
  "settings.app-settings.show-shortcuts-hints": "Show keyboard shortcut hints",
  "settings.app-settings.show-social-network-safety-link-alert": "Show social network social link alert",
  "settings.app-settings.show-system-notifications": "Show system notifications",
  "settings.app-settings.theme": "App theme",
  "settings.app-settings.use-sound-notifications": "Use sound notifications",
  "settings.auto-scale-acknowledgment.description": "The app is automatically scaled to match your screen for optimal readability and usability.",
  "settings.auto-scale-acknowledgment.description-2": "You can change this behavior anytime in Settings.",
  "settings.auto-scale-acknowledgment.title": "Auto Scaling Enabled",
  "settings.google.authorization": "Google Authorization",
  "settings.google.connect-error": "Unable to connect Google account",
  "settings.google.disconnect-description": "You will no longer be able to sign in with your associated Google account",
  "settings.google.disconnect-title": "Disconnect Google",
  "settings.google.success": "Google account has been successfully connected",
  "settings.google.unassign-success": "Google account has been disconnected",
  "settings.incognito.label": "Incognito mode",
  "settings.language.auto": "Auto",
  "settings.language.auto-description": "Based on system settings",
  "settings.language.change-successful": "Language has been changed successfully",
  "settings.local-password.item": "Local password",
  "settings.local-password.title": "Change Local Password",
  "settings.local-password.toast-changed": "Your local password has been updated",
  "settings.password.item": "Account password",
  "settings.password.title": "Change Password",
  "settings.password.title-current": "Enter your current password",
  "settings.password.title-new": "Enter a new password",
  "settings.password.title-new-repeat": "Repeat a new password",
  "settings.password.toast-changed": "Your password has been updated",
  "settings.password.toast-repeat-error": "Passwords entered do not match",
  "settings.password.toast-wrong": "Your current password is incorrect",
  "settings.security": "Security",
  "settings.security.otp-quick-login": "Always require OTP",
  "settings.security.otp-quick-login.description": "Always require a one-time code for login.<br />If disabled, the system will request a code only when additional verification is needed.",
  "settings.trading-mode": "Trading mode",
  "settings.trading-mode.advanced": "Advanced",
  "settings.trading-mode.advanced.description": "Trade from your own wallets. You hold the keys, you sign every trade, and you pay network fees yourself.",
  "settings.trading-mode.basic": "Basic",
  "settings.trading-mode.basic.description": "Trade from one balance you top up. Trades are signed for you, so there is no wallet to set up and nothing to approve.",
  "settings.trading-mode.note": "Switching moves no money. Your wallets keep their balances and your Basic balance keeps its own — this only chooses which one you trade from. It is set on your account, so the bot follows it too.",
  "settings.telegram.authorization": "Telegram Authorization",
  "settings.telegram.connect-error": "Unable to connect Telegram account",
  "settings.telegram.disconnect-description": "You will no longer be able to sign in with your associated Telegram account",
  "settings.telegram.disconnect-title": "Disconnect Telegram",
  "settings.telegram.success": "Telegram account has been successfully connected",
  "settings.telegram.unassign-success": "Telegram account has been disconnected",
  "settings.twitter.authorization": "X(Twitter) Authorization",
  "settings.twitter.connect-error": "Unable to connect X(Twitter) account",
  "settings.twitter.disconnect-description": "You will no longer be associated with this X(Twitter) account",
  "settings.twitter.disconnect-title": "Disconnect X(Twitter)",
  "settings.twitter.label": "X(Twitter) Account",
  "settings.twitter.success": "X(Twitter) account has been successfully connected",
  "settings.twitter.unassign-success": "X(Twitter) account has been disconnected",
  "shortcuts": "Shortcuts",
  "shortcuts.copy-trade-page-link": "Copy the trade page link to the clipboard",
  "shortcuts.open-clipboard-pair": "Open the pair from the clipboard",
  "shortcuts.open-profile": "Open profile",
  "shortcuts.open-search-modal": "Open the search modal",
  "shortcuts.open-settings-modal": "Open settings modal",
  "splash-points.description": "Each token earns Splash-Points based on 3 factors:",
  "splash-points.description-factors": "volume, swaps, and raids",
  "splash-points.doc-title": "Splash Points Info",
  "splash-points.error": "Something went wrong. Please try again later.",
  "splash-points.loading": "Loading token information",
  "splash-points.logarithm-disclaimer": "Logarithms help balance huge values, while squaring amplifies well-coordinated raids",
  "splash-points.makers": "Makers",
  "splash-points.makers-description": "Unique wallets trading the token.",
  "splash-points.makers-formula": "points = log(makers x 20) x 2.5",
  "splash-points.raids": "Raids",
  "splash-points.raids-description": "Strong social engagement (likes, retweets, replies, bookmarks) gives a big boost! raidCoefficient is a small multiplier to scale raid impact (e.g. 0.002).",
  "splash-points.raids-formula": "points = (power points / (1.6 × raids + 1))² × (1 + 0.01 × raids)",
  "splash-points.swaps": "Swaps",
  "splash-points.swaps-description": "More swap activity (buys and sells) means higher scores — frequent trading boosts visibility.",
  "splash-points.swaps-formula": "points = log(swaps x 20) x 2.5",
  "splash-points.title": "How Are Splash Points Calculated?",
  "splash-points.volume": "Volume",
  "splash-points.volume-description": "Higher trading volume earns more points, but with diminishing returns thanks to the logarithm.",
  "splash-points.volume-formula": "points = log(volume usd x 10) x 10",
  "summary.your_summary": "Your Summary",
  "support": "Support",
  "support.chat-intro-you-started": "You start the chat",
  "support.close-ticket": "Close Ticket",
  "support.contact-support": "Contact support",
  "support.create-new-ticket": "Create New Ticket",
  "support.empty-messages": "No messages, yet..",
  "support.form.email-optional-label": "Email (optional)",
  "support.form.email-placeholder": "example@example.com",
  "support.form.email-replies-checkbox": "If you want to receive a reply by email",
  "support.form.name-label": "Name",
  "support.form.name-placeholder": "Ben Zhou",
  "support.form.problem-description-label": "Problem description",
  "support.form.problem-description-placeholder": "Describe your problem in detail...",
  "support.form.problem-title-label": "Problem title",
  "support.form.problem-title-placeholder": "Title of your problem...",
  "support.form.submit-create-ticket": "Create Ticket",
  "support.heading-brand": "Support",
  "support.new-ticket": "New Ticket",
  "support.past-tickets": "Past Tickets",
  "support.reopen-ticket": "Reopen Ticket",
  "support.ticket-created-label": "created",
  "support.ticket-status-updated.active": "Ticket {{subject}} reopened",
  "support.ticket-status-updated.closed": "Ticket {{subject}} closed",
  "support.tickets-admin.active-tickets": "In Progress",
  "support.tickets-admin.closed-tickets": "Closed",
  "support.tickets-admin.unread-tickets": "New Tickets",
  "support.typing": "Support typing",
  "support.welcome-brand": "Support!",
  "support.welcome-message": "Our support is available 24/7 and is ready to help with any questions.",
  "support.welcome-title-to": "to ",
  "support.welcome-title-welcome": "Welcome",
  "swap": "Swap",
  "swap_other": "Swaps",
  "swap.base-label": "You're sending",
  "swap.completed": "Swap Completed!",
  "swap.confirm_swap": "Confirm swap",
  "swap.error": "Swap Failed",
  "swap.load-pools": "Load pools",
  "swap.loading-pools": "Loading pools",
  "swap.no-pool-available": "No pools available",
  "swap.no-pool-available.description": "Unfortunately, there are no pools available for this pair, try to choose another pair",
  "swap.pool-loading-error": "Unable to load pools",
  "swap.processing": "Processing Swap",
  "swap.quote-label": "You're receiving",
  "swap.review_swap": "Review swap",
  "swap.seconds-short": "sec",
  "swap.select-pool": "Select pool",
  "swap.swap-screen.title": "Currency swap",
  "table.active": "Active",
  "table.audit.cr": "Freeze Auth Disabled",
  "table.audit.cv": "Mint Auth Disabled",
  "table.audit.nhp": "{{percentage}}% of liquidity pool burned. Green check if more than 80%",
  "table.audit.t10": "{{percentage}}% owned by top 10 holders. Green check if top 10 holders hold less than 15%",
  "table.bought": "Bought",
  "table.filter.at-least-1-social": "With at least 1 social",
  "table.filter.keywords-placeholder": "Keyword 1, Keyword 2 ... (max 5)",
  "table.filter.lp-burned": "LP Burned",
  "table.filter.mint-auth-disabled": "Mint Auth Disabled",
  "table.filter.top-10-holders": "Top 10 Holders",
  "table.holders": "Holders",
  "table.maker": "Maker",
  "table.market_cap": "Market Cap",
  "table.message.login_to_account": "log in to your account",
  "table.message.no_data": "Data is not available",
  "table.network_balance": "{{network}} Bal",
  "table.pnl": "Pnl",
  "table.quick_buy": "Quick Buy",
  "table.rank": "Rank",
  "table.remaining": "Remaining",
  "table.safety_checks": "CV/CR/NHP/T10",
  "table.sold": "Sold",
  "table.swaps": "Swaps",
  "theme.button.title": "Theme",
  "theme.custom.acid": "Acid",
  "theme.custom.amber": "Amber",
  "theme.custom.appearance": "Appearance",
  "theme.custom.appearance.dark": "Dark",
  "theme.custom.appearance.light": "Light",
  "theme.custom.appearanceColor": "Base color",
  "theme.custom.background": "Background",
  "theme.custom.baseTheme": "Base theme",
  "theme.custom.blue": "Blue",
  "theme.custom.boostButton": "Boost button",
  "theme.custom.boostGlow": "Boost glow",
  "theme.custom.boostGradientFrom": "Boost gradient from",
  "theme.custom.boostGradientTo": "Boost gradient to",
  "theme.custom.boostIcon": "Boost icon",
  "theme.custom.bronze": "Bronze",
  "theme.custom.candleGreen": "Rising candle",
  "theme.custom.candleGreenBorder": "Rising candle border",
  "theme.custom.candleGreenWick": "Rising candle wick",
  "theme.custom.candleRed": "Falling candle",
  "theme.custom.candleRedBorder": "Falling candle border",
  "theme.custom.candleRedWick": "Falling candle wick",
  "theme.custom.cyan": "Cyan",
  "theme.custom.down": "Down",
  "theme.custom.downAccent": "Down accent",
  "theme.custom.error": "Error",
  "theme.custom.errorAccent": "Error accent",
  "theme.custom.golden": "Golden",
  "theme.custom.gray": "Gray",
  "theme.custom.green": "Green",
  "theme.custom.name": "Custom",
  "theme.custom.neutral": "Neutral",
  "theme.custom.neutralAccent": "Neutral accent",
  "theme.custom.orange": "Orange",
  "theme.custom.pink": "Pink",
  "theme.custom.primary": "Primary",
  "theme.custom.purple": "Purple",
  "theme.custom.red": "Red",
  "theme.custom.silver": "Silver",
  "theme.custom.subscriptionButton": "Subscription button",
  "theme.custom.subscriptionGlow": "Subscription glow",
  "theme.custom.subscriptionGradientFrom": "Subscription gradient from",
  "theme.custom.subscriptionGradientTo": "Subscription gradient to",
  "theme.custom.subscriptionIcon": "Subscription icon",
  "theme.custom.success": "Success",
  "theme.custom.successAccent": "Success accent",
  "theme.custom.tab.base": "Base",
  "theme.custom.tab.candle": "Candle",
  "theme.custom.tab.color": "Colors",
  "theme.custom.tab.intents": "Intents",
  "theme.custom.tab.premium": "Premium",
  "theme.custom.tab.trend": "Trend",
  "theme.custom.text": "Text",
  "theme.custom.up": "Up",
  "theme.custom.upAccent": "Up accent",
  "theme.custom.warning": "Warning",
  "theme.custom.warningAccent": "Warning accent",
  "theme.custom.yellow": "Yellow",
  "theme.deluge.description": "kol.trade theme",
  "theme.deluge.name": "kol.trade",
  "theme.delugeLight.name": "kol.trade Light",
  "theme.dialog.title": "Change color scheme",
  "theme.monokai.name": "Monokai",
  "theme.photgone.name": "Photgone",
  "theme.test.description": "Test theme",
  "theme.test.name": "Test",
  "token": "Token",
  "token_other": "Tokens",
  "top-trader_other": "Top Traders",
  "topbar.position.recent": "Recent",
  "trade": "Trade",
  "trade_other": "Trades",
  "trade_settings": "Trade settings",
  "trade_settings.anti_mev": "Anti MEV",
  "trade_settings.anti_mev_tooltip": "MEV protection allows you to secure your transactions using Jito. If it's disabled, your transactions will be more likely to succeed, but there may be risks of MEV attacks.",
  "trade_settings.anti_mev.info": "<p>MEV attackers affect asset prices by changing the order of transaction packaging on public nodes on the network, inserting transactions before and after your transactions, thus causing financial losses.</p><p>MEV protection allows you to secure your transactions using Jito. If it's disabled, your transactions will be more likely to succeed, but there may be risks of MEV attacks.</p>",
  "trade_settings.anti_mev.info-title": "MEV Protection",
  "trade_settings.deadline": "Deadline",
  "trade_settings.deadline-min-message": "Minimum deadline is 1 minute",
  "trade_settings.flexible_gas_price": "Flexible Gas Price",
  "trade_settings.flexible_gas_price_tooltip": "If enabled, the gas price will be adjusted automatically based on network conditions",
  "trade_settings.gas_price": "Gas Price",
  "trade_settings.gas_price_tooltip": "The price you are willing to pay for gas",
  "trade_settings.jito_tip": "Jito Tip",
  "trade_settings.jito_tip_max_message": "Jito Tip must be less than {{max}}",
  "trade_settings.jito_tip_tooltip": "The additional fee you're willing to pay to Jito validators to prioritize your transaction",
  "trade_settings.max_gas_price": "Max Gas Price",
  "trade_settings.max_gas_price_tooltip": "The maximum price you are willing to pay for gas",
  "trade_settings.max_priority_fee_per_gas": "Max Priority Fee Per Gas",
  "trade_settings.max_priority_fee_per_gas_tooltip": "The maximum price you are willing to pay for priority fee",
  "trade_settings.max-auto-priority": "Max Auto Priority",
  "trade_settings.preset-settings": "Preset settings",
  "trade_settings.priority_fee": "Priority Fee",
  "trade_settings.priority_fee_max_message": "Priority fee must be less than {{max}}",
  "trade_settings.priority_fee_tooltip": "The price you are willing to pay for priority fee",
  "trade_settings.priority-and-tip-fee": "Priority and Tip Fee",
  "trade_settings.reset_settings": "Reset to defaults",
  "trade_settings.saved": "Trade settings have been saved successfully.",
  "trade_settings.transaction-fee": "Transaction Fee",
  "trade-settings.api-key": "API key",
  "trade-settings.custom-rpc": "Custom RPC",
  "trade-settings.custom-rpc-description": "Use your own RPC endpoint",
  "trade-settings.custom-rpc-placeholder": "https://your-rpc-endpoint.com",
  "trade-settings.custom-rpc-tooltip": "Send transactions through your own RPC endpoint instead of Helius Sender.",
  "trade-settings.enter-slippage": "Enter slippage",
  "trade-settings.execution-route": "Sender",
  "trade-settings.execution-route-tooltip": "Choose how your transactions are submitted to the network. Only one route can be active at a time.",
  "trade-settings.helius-sender": "Helius Sender",
  "trade-settings.helius-sender-description": "Send through Helius global network",
  "trade-settings.helius-sender-tooltip": "Ultra-low latency transaction submission via Helius staked connections",
  "trade-settings.location": "Location",
  "trade-settings.quick-buy-amount": "Quick buy amount",
  "trade-settings.quick-buy-amount-updated-error-message": "Unable to update quick buy amount",
  "trade-settings.quick-buy-amount-updated-message": "Quick buy has been set to {{amount}}",
  "trade-settings.quick-buy-amount-updated-message-max": "Quick buy can't be more than {{amount}}",
  "trade-settings.quick-buy-title": "Quick buy settings",
  "trade-settings.quick-buy.section.cooking": "Cooking table",
  "trade-settings.quick-buy.section.explore-feeds": "Explore feed",
  "trade-settings.quick-buy.section.new-pairs": "New pairs table",
  "trade-settings.quick-buy.section.trending": "Trending table",
  "trade-settings.quick-buy.section.wallet-tracker": "Wallet tracker",
  "trade-settings.rpc-endpoint": "RPC Endpoint",
  "trade-settings.zero-slot-description": "Send through 0slot",
  "trade-settings.zero-slot-tooltip": "Premium tx sender. Requires an API key from 0slot.trade",
  "trade-settings.zero-slot.api-key-placeholder": "Your 0slot.trade API key",
  "trade.button.edit": "Edit",
  "trade.buy-first": "First buy",
  "trade.buy-more": "Buy more",
  "trade.cancelled-at": "Cancelled at",
  "trade.chart.open-transactions-error": "Unable to open all transactions",
  "trade.chart.open-transactions-error-description": "Allow pop-ups and redirects for this site to open multiple transaction tabs.",
  "trade.completed-at": "Completed at",
  "trade.entry-price": "Entry price",
  "trade.expire-date": "Expire date",
  "trade.expired": "Expired",
  "trade.expired-at": "Expired at",
  "trade.expires-in": "Expires in {{interval}}",
  "trade.failed-at": "Failed at",
  "trade.filters.common.apply": "Apply",
  "trade.filters.common.reset": "Reset",
  "trade.filters.maker.header": "Filter by maker",
  "trade.filters.maker.label": "Enter Maker",
  "trade.filters.maker.trigger": "Maker",
  "trade.filters.total.header": "Filter Total {{currency}}",
  "trade.holders-charts.holders": "Holders",
  "trade.holders-charts.snipers_holding": "Snipers holding %",
  "trade.holders-charts.top_10_holders": "Top 10 Holders",
  "trade.instant-trade": "Instant Trade",
  "trade.liquidity-short": "LQ",
  "trade.market-cap-short": "MC",
  "trade.my-trades": "My Trades",
  "trade.pair-information.fees-paid": "Fees paid",
  "trade.pair-information.freeze": "Freeze",
  "trade.pair-information.mint": "Mint",
  "trade.pnl.share.title": "Share PnL",
  "trade.pnl.sold-all": "Sold all",
  "trade.price-short": "P",
  "trade.quick-buy.min-amount-amount": "Minimum amount out",
  "trade.sell-all": "Sell all",
  "trade.sell-partial": "Sell partial",
  "trade.slippage": "Slippage",
  "trade.slippage_tooltip": "The maximum difference between expected and actual price due to market volatility. Higher slippage allows trades to complete more easily but may result in worse rates.",
  "trade.stop-loss": "Stop Loss",
  "trade.stop-loss-short": "SL",
  "trade.table.new-data": "New trades",
  "trade.table.new-pairs": "New pairs",
  "trade.table.new-trades": "New trades",
  "trade.take-profit": "Take Profit",
  "trade.take-profit-short": "TP",
  "trade.target-mcap": "Target market cap",
  "trade.target-price": "Target price",
  "trade.trade-panel": "Panel",
  "trade.trigger-price": "Triggered at",
  "trade.type.tooltip.burn": "Tokens have been burned",
  "trade.type.tooltip.buy": "Buy",
  "trade.type.tooltip.liquidityAdd": "Liquidity added to the pool",
  "trade.type.tooltip.liquidityRemove": "Liquidity removed from the pool",
  "trade.type.tooltip.lpBurn": "LP Tokens have been burned",
  "trade.type.tooltip.poolInit": "Pool Initialized",
  "trade.type.tooltip.poolMigrate": "Pool Migrated",
  "trade.type.tooltip.sell": "Sell",
  "trading": "Trading",
  "trading-activity": "Trading Activity",
  "trading-activity.description": "Track your consistency and PnL",
  "trading.add_funds": "Add Funds",
  "trading.approve-tokens": "Approve tokens",
  "trading.approving-tokens": "Approving tokens",
  "trading.audit.bot_users": "Bot Users",
  "trading.audit.bundlers_holding": "Bundlers Holding",
  "trading.audit.bundlers.holding-tooltip": "Bundlers hold {{percentage}}% of the total supply",
  "trading.audit.button_proceed": "Proceed to trade",
  "trading.audit.ca_deployer": "CA Deployer",
  "trading.audit.deployer_address": "Deployer Address",
  "trading.audit.description": "If you proceed to trade, do so with caution and review the complete security audit carefully.",
  "trading.audit.dev_bought_tooltip": "Dev bought {{timeAt}} ago",
  "trading.audit.dev_holding": "Dev Holding",
  "trading.audit.dev_holding_tooltip": "Dev Holds {{percentage}}%",
  "trading.audit.dev_holding.short": "Dev H.",
  "trading.audit.dev_migrations": "Dev Migrations",
  "trading.audit.dev_sold_tooltip": "Dev sold {{timeAt}} ago",
  "trading.audit.holders_tooltip": "Number of holders",
  "trading.audit.insider_holding": "Insider Holding",
  "trading.audit.insider_holding_tooltip": "Insiders hold {{percentage}}% of the total supply",
  "trading.audit.is_freezable": "Is Freezable?",
  "trading.audit.is_mintable": "Is Mintable?",
  "trading.audit.is_mintable.hint": "Check if mint authority is null",
  "trading.audit.is_token_data_mutable": "Is Token Data Mutable",
  "trading.audit.is_token_data_mutable.hint": "Check if token data is mutable",
  "trading.audit.is-freezable.warning-tooltip": "Token is freezable",
  "trading.audit.is-mintable.warning-tooltip": "Token is mintable",
  "trading.audit.lp_burned": "LP Burned",
  "trading.audit.lp_burned.hint": "Liquidity Pool Tokens that have been burned",
  "trading.audit.lp_burned.tooltip-percentage": "{{percents}} of LP tokens have been burned",
  "trading.audit.lp_creator": "LP Creator",
  "trading.audit.lp-burned.warning-tooltip": "LP not fully burned ({{burnedPercent}}%)",
  "trading.audit.not_show_again": "Never show this again",
  "trading.audit.owner_balance": "Owner Balance",
  "trading.audit.snipers": "Snipers",
  "trading.audit.snipers_holding": "Snipers Holding",
  "trading.audit.snipers_tooltip": "Number of snipers",
  "trading.audit.snipers.holding-tooltip": "Snipers hold {{percentage}}% of the total supply",
  "trading.audit.title": "No Security Issues Detected",
  "trading.audit.title_warnings_one": "{{count}} Security Issue Detected",
  "trading.audit.title_warnings_other": "{{count}} Security Issues Detected",
  "trading.audit.top_10_holders": "Top 10 Holders",
  "trading.audit.top_10_holders_tooltip": "Top 10 Holders hold {{percentage}}% of the total supply",
  "trading.audit.top_10_holders.hint": "Percentage of Supply held by Top 10 Holders",
  "trading.audit.top_10_holders.short": "Top 10 H.",
  "trading.audit.update_authority": "Update Authority",
  "trading.audit.update_authority.none": "None",
  "trading.buy": "Buy",
  "trading.buy-quote-for": "Buy <0 /> <1 /> for <2 />",
  "trading.buy.active-title": "Processing purchase of <amount />",
  "trading.buy.error-title": "Unable to buy {{ticker}}",
  "trading.buy.success-title": "Successfully bought <amount /> for <amountNative />",
  "trading.buys": "Buys",
  "trading.check-approval": "Check approval",
  "trading.check-approval-error": "Unable to check token approval. Please try again.",
  "trading.checking-approval": "Checking approval",
  "trading.deluge_trending": "kol.trade Trending",
  "trading.dev-burn.burnt-rate": "Burnt rate",
  "trading.dev-burn.dev-burnt": "Dev Burnt",
  "trading.dev.short": "Dev",
  "trading.error.insufficient-funds": "Insufficient balance {{ticker}}",
  "trading.error.no-amount": "Enter amount",
  "trading.error.no-currency": "Select a token",
  "trading.error.no-route": "No route available",
  "trading.favorites.added": "{{ticker}} added to watchlist",
  "trading.favorites.empty-description": "And keep an eye on its changes",
  "trading.favorites.empty-title": "Let’s start your watchlist",
  "trading.favorites.error": "Something went wrong while adding/removing from watchlist",
  "trading.favorites.removed": "{{ticker}} removed from watchlist",
  "trading.gas": "Gas",
  "trading.limit_buy": "Limit buy",
  "trading.limit_order": "Limit order",
  "trading.limit_sell": "Limit sell",
  "trading.limit-buy": "Limit buy",
  "trading.limit-order.order-error": "Order failed",
  "trading.limit-order.order-error-description": "We couldn't place your order due to an unexpected issue. Please try again or contact support if the problem persists.",
  "trading.limit-order.order-placed": "Order successfully placed!",
  "trading.limit-order.order-placed-description": "Your order has been placed successfully. You can track its progress in the Orders section.",
  "trading.limit-order.processing-order": "Processing Order",
  "trading.limit-order.processing-order-description": "Your order is being processed. This may take a few moments, please wait.",
  "trading.limit-rate-by": "Rate by",
  "trading.limit-sell": "Limit sell",
  "trading.low-liquidity-alert": "This pair has very little liquidity",
  "trading.market-buy": "Market buy",
  "trading.market-cap": "Market Cap",
  "trading.market-order.processing-transaction": "Processing Transaction",
  "trading.market-order.processing-transaction-description": "Your transaction is being processed. This may take a few moments, please wait.",
  "trading.market-order.transaction-error": "Transaction failed",
  "trading.market-order.transaction-error-description": "We couldn't process your transaction due to an unexpected issue. Please try again or contact support if the problem persists.",
  "trading.market-order.transaction-placed": "Transaction completed!",
  "trading.market-order.transaction-placed-description": "Your transaction has been successfully executed. You can find more information in transaction history.",
  "trading.market-sell": "Market sell",
  "trading.mev_protection": "MEV Protection",
  "trading.navigation.favorites": "Favorites",
  "trading.navigation.last-pairs": "Last pairs",
  "trading.navigation.limit_orders": "Limit Orders",
  "trading.navigation.orders": "Orders",
  "trading.navigation.positions": "Positions",
  "trading.navigation.search": "Search",
  "trading.navigation.wallets": "Wallets",
  "trading.no-wallet-title": "Create your first wallet to start trading",
  "trading.order.amount": "Amount",
  "trading.order.bribe-tooltip": "Bribe",
  "trading.order.dca": "DCA",
  "trading.order.gas-priority-fee-tooltip": "Gas Priority Fee",
  "trading.order.limit": "Limit",
  "trading.order.limit-in-bot": "Limit orders are placed in the bot for now.",
  "trading.order.market": "Market",
  "trading.order.slippage-percentage-tooltip": "Slippage Percentage",
  "trading.order.token-orders": "Token orders",
  "trading.orders.no-orders.active": "You don't have active orders",
  "trading.orders.no-orders.cancelled": "You don't have cancelled orders",
  "trading.orders.no-orders.completed": "You don't have completed orders",
  "trading.orders.no-orders.expired": "You don't have expired orders",
  "trading.orders.no-orders.failed": "You don't have failed orders",
  "trading.orders.no-orders.sub-title": "Your limit orders will be displayed here",
  "trading.orders.no-orders.title": "You don't have orders",
  "trading.orders.view-all": "You can view all limit orders here",
  "trading.pair.address-copied-to-clipboard": "Pair address has been copied!",
  "trading.pair.buy_volume": "Buy Vol",
  "trading.pair.buyers": "Buyers",
  "trading.pair.buys": "Buys",
  "trading.pair.makers": "Makers",
  "trading.pair.sell_volume": "Sell Vol",
  "trading.pair.sellers": "Sellers",
  "trading.pair.sells": "Sells",
  "trading.pair.share-link-copied": "Share link has been copied!",
  "trading.pair.tx": "Txns",
  "trading.pair.volume": "Volume",
  "trading.parameters.avg_wait_time": "Avg Wait Time",
  "trading.parameters.deadline": "Deadline",
  "trading.parameters.fee": "Fee",
  "trading.parameters.max_slippage": "Max Slippage",
  "trading.parameters.minimum_receive": "Minimum receive",
  "trading.parameters.network_cost": "Network cost",
  "trading.parameters.platform_fee": "Platform Fee",
  "trading.parameters.price_impact": "Price Impact",
  "trading.parameters.rate": "Rate",
  "trading.place-order": "Place Order",
  "trading.position.invested": "Bought",
  "trading.position.pnl_change": "PnL Change",
  "trading.position.remaining": "Remaining",
  "trading.position.sold": "Sold",
  "trading.position.stop-loss-at": "Stop loss at",
  "trading.position.unrealized": "Unrealized",
  "trading.position.unrealized-pnl": "Unrealized PnL",
  "trading.positions.no-positions.sub-title": "Your positions will be displayed here",
  "trading.positions.no-positions.title": "You don't have positions",
  "trading.positions.not-set": "Not set",
  "trading.positions.view-all.title": "You can view all of your positions here",
  "trading.quick_trade": "Quick trade",
  "trading.quote-pending": "Calculating",
  "trading.quote-retry": "Get quote",
  "trading.quote.not-enough-liquidity": "Not enough liquidity",
  "trading.rate-by": "Rate by",
  "trading.rate-by.market-cap": "Market Cap",
  "trading.rate-by.market-cap-is": "Market Cap is",
  "trading.rate-by.price": "Price",
  "trading.rate-by.price-is": "Price is",
  "trading.rate-by.rate-by-market-cap": "Rate by MC",
  "trading.rate-by.rate-by-price": "Rate by Price",
  "trading.recent_pairs": "Recent Pairs",
  "trading.recent-pairs.no-recent-pairs.sub-title": "Your recently traded pairs will be displayed here",
  "trading.recent-pairs.no-recent-pairs.title": "You don't have recent pairs!",
  "trading.recent-pairs.view-all": "You can view all recent pairs here",
  "trading.search.recent-searches": "Recent Searches",
  "trading.search.recent-searches.empty": "You don't have any recent searches",
  "trading.sell": "Sell",
  "trading.sell-all": "Sell All",
  "trading.sell-all-positions": "Sell all positions",
  "trading.sell-all-positions-description": "Are you sure you want to sell all {{ticker}} positions?",
  "trading.sell-amount": "Sell amount",
  "trading.sell-high": "Sell High",
  "trading.sell-low": "Sell Low",
  "trading.sell-position-snackbar.failed": "Selling position failed",
  "trading.sell-position-snackbar.pending": "Selling position in progress",
  "trading.sell-position-snackbar.success": "Selling position completed",
  "trading.sell-position-snackbar.successSome": "Partially sold position",
  "trading.sell-quote-for": "Sell <0 /> <1 /> for <2 />",
  "trading.sell.active-title": "Processing sale of <amount />",
  "trading.sell.error-title": "Unable to sell {{ticker}}",
  "trading.sell.success-title": "Successfully sold <amount />",
  "trading.sells": "Sells",
  "trading.stop_loss": "Stop loss",
  "trading.swap": "Swap",
  "trading.swap.error-title": "Swap failed",
  "trading.swap.getting-quote-description": "Fetching quote",
  "trading.swap.processing-title": "Processing swap",
  "trading.swap.success-title": "Swap completed",
  "trading.take_profit": "Take profit",
  "trading.tokens-approve-error": "Unable to approve tokens",
  "trading.tokens-approve-error.insufficient": "Insufficient funds to approve token. Please deposit funds to cover gas fees.",
  "trading.tokens-approved-message": "Tokens have been approved",
  "trading.transaction-confirmation-failed.message": "Transaction confirmation failed",
  "trading.transaction-confirmed.message": "Transaction confirmed",
  "trading.you_pay": "You Pay",
  "trading.you_receive": "You'll receive",
  "trading.you_will_pay": "You will pay",
  "transaction_one": "Transaction",
  "transaction_other": "Transactions",
  "transaction.block_number": "Block number",
  "transaction.history": "Transaction history",
  "transaction.history.empty-description": "Your transactions will appear here",
  "transaction.history.empty-description.another": "User's transactions will appear here",
  "transaction.history.empty-title": "Transaction history is empty",
  "transaction.nonce": "Nonce",
  "transaction.see_in_explorer": "See in Explorer",
  "transaction.sent-to": "Sent to",
  "transaction.status_active": "Active",
  "transaction.status_all": "All statuses",
  "transaction.status_cancelled": "Cancelled",
  "transaction.status_failed": "Failed",
  "transaction.status_finished": "Finished",
  "transaction.status_pending": "Pending",
  "transaction.status_success": "Success",
  "transaction.transaction_details": "Transaction Details",
  "transaction.transaction_hash_copied_message": "Transaction hash {{hash}} copied to clipboard!",
  "transaction.transactions_all": "All transactions",
  "transaction.type_buy": "Buy",
  "transaction.type_deposit": "Receiving",
  "transaction.type_sell": "Sell",
  "transaction.type_swap": "Swap",
  "transaction.type_transfer": "Transfer",
  "transactions": "Transactions",
  "transfer": "Transfer",
  "transfer.amount-plus-gas-fee": "Amount + gas fee",
  "transfer.balance-after": "Balance after",
  "transfer.error": "Unable to process transfer",
  "transfer.estimated-changes": "Estimated changes",
  "transfer.max-amount": "Max amount",
  "transfer.send-to": "send to",
  "transfer.transfer-processing": "Processing...",
  "transfer.transfer-processing-message": "Transaction in progress! Blockchain validation is underway. This may take a few minutes. You can always check status in transaction history",
  "transfer.validation.insufficient-funds": "You don't have enough {{ticker}} to send",
  "transfer.you-send": "You send",
  "trending": "Trending",
  "trending.loading-error": "Unable to load trending pairs. Please try again later.",
  "unsafe-url-dialog.beware-of-phishing-scams": "Beware of Phishing Scams:",
  "unsafe-url-dialog.continue-on": "Continue on",
  "unsafe-url-dialog.description": "Stay Safe",
  "unsafe-url-dialog.dont-show-this-warning-again": "Don't show this warning again",
  "unsafe-url-dialog.i-understand": "I understand",
  "unsafe-url-dialog.if-something-feels-off": "If something feels off, don't interact and please reach out to us on Telegram or Discord",
  "unsafe-url-dialog.never-connect-your-wallet": "Never connect your wallet or confirm transactions unless you're 100% sure of the source's legitimacy",
  "unsafe-url-dialog.never-enter-your-credentials": "Never enter your Discord or Telegram credentials to prove you are not a bot",
  "unsafe-url-dialog.protect-your-wallet": "Protect Your Wallet:",
  "unsafe-url-dialog.title": "Warning",
  "unsafe-url-dialog.when-in-doubt-stop": "When in Doubt, Stop!:",
  "update.about": "About update",
  "update.download_error_message": "Error while downloading the update",
  "update.installation_error_message": "Error while installing the update",
  "update.latest_update_message": "No new updates are available",
  "update.latest_update_title": "Latest update installed",
  "update.new_version_available": "New version available: {{version}}",
  "update.new_version_message": "Download and install update",
  "update.relaunch_error_message": "Error during app relaunch",
  "update.update_available": "A new version of the app is available",
  "update.update_check_error_message": "Error while checking for updates",
  "update.update_checking": "Checking for update",
  "update.update_ready": "Update is downloaded",
  "update.update_ready_message": "After installation, the app will relaunch and the changes will take effect",
  "validation.file-too-large": "Size too big",
  "validation.invalid_address": "Invalid address",
  "validation.max_length": "Maximum length is {{length}}",
  "validation.required": "Required",
  "wallet_one": "wallet",
  "wallet_other": "wallets",
  "wallet-manager.add_color": "Add color",
  "wallet-manager.edit.title": "Edit Wallet",
  "wallet-manager.hidden-assets": "Hidden Assets",
  "wallet-manager.page.title": "Wallet Manager",
  "wallet-profile.activity.bought": "Bought",
  "wallet-profile.activity.sold": "Sold",
  "wallet-profile.bucket.gain-0-200": "0 – 200%",
  "wallet-profile.bucket.gain-200-500": "200 – 500%",
  "wallet-profile.bucket.gain-over-500": "Over 500%",
  "wallet-profile.bucket.loss-0-50": "0 – -50%",
  "wallet-profile.bucket.loss-over-50": "Under -50%",
  "wallet-profile.tab.degen-hours": "Degen Hours",
  "wallet-profile.degen-hours.note": "Each square is the average profit one trade made in that local hour. An hour with no trades is left blank.",
  "wallet-profile.degen-hours.over-trades": "over {{count}} trades",
  "wallet-profile.degen-hours.win-rate": "{{rate}}% win rate",
  "wallet-profile.degen-hours.best": "Best hour",
  "wallet-profile.degen-hours.average": "Avg",
  "wallet-profile.degen-hours.per-trade": "/ trade",
  "wallet-profile.degen-hours.days": "last {{days}} days",
  "wallet-profile.column.action": "Action",
  "wallet-profile.column.amount": "Amount",
  "wallet-profile.column.asset": "Asset",
  "wallet-profile.column.counterparty": "Counterparty",
  "wallet-profile.column.detail": "Token / Wallet",
  "wallet-profile.column.time": "Time",
  "wallet-profile.column.value": "Value",
  "wallet-profile.column.value-note": "Converted at today's price, not the price at the time.",
  "wallet-profile.consistency": "Consistency",
  "wallet-profile.consistency-tooltip": "Realized PnL against its own day-to-day swing. Higher means steadier, not bigger.",
  "wallet-profile.funding.by": "Funded by",
  "wallet-profile.funding.unknown": "First funding not known — this wallet was trading before we were watching",
  "wallet-profile.tab.activity": "Activity",
  "wallet-profile.tab.transfers": "Transfers",
  "wallet-profile.transfers.empty": "No money moved in the last {{days}} days",
  "wallet-profile.transfers.in": "Received",
  "wallet-profile.transfers.note": "SOL and stablecoins, last {{days}} days. Token transfers are not indexed.",
  "wallet-profile.transfers.out": "Sent",
  "wallet-profile.not-enough-days": "Not enough days to chart yet",
  "wallet-profile.positions": "Positions",
  "wallet-profile.realized-over-time": "Realized PnL, 30 days",
  "wallet-profile.received": "Received",
  "wallet-profile.spent": "Spent",
  "wallet-profile.title": "Wallet profile",
  "wallet-profile.tab.dev-tokens": "Dev Tokens",
  "wallet-profile.tab.history": "History",
  "wallet-profile.tab.positions": "Active Positions",
  "wallet-profile.tab.top": "Top 100",
  "wallet-profile.token": "Token",
  "wallet-profile.tokens-traded": "Tokens traded",
  "wallet-profile.trades": "Trades",
  "wallet-profile.unpriced": "No cost recorded",
  "wallet-profile.unpriced-note": "This token was bought in a pool that reported no price, so its profit is unknown rather than zero.",
  "wallet-tracker": "Wallet Tracker",
  "wallet-tracker.add-wallet.button": "Add wallet",
  "wallet-tracker.add-wallet.success": "Wallet has been added for tracking!",
  "wallet-tracker.add-wallet.title": "Add wallet",
  "wallet-tracker.alerts": "Alerts",
  "wallet-tracker.delete-wallet.success": "Wallet has been deleted from tracking!",
  "wallet-tracker.dialog.title": "Wallet Tracker",
  "wallet-tracker.edit-wallet.success": "Wallet has been edited successfully",
  "wallet-tracker.filter.tags.name": "Filter by tags",
  "wallet-tracker.filter.tags.placeholder": "Enter tags",
  "wallet-tracker.following": "Following",
  "wallet-tracker.monitor-square": "Monitor Square",
  "wallet-tracker.new-alerts": "New alerts",
  "wallet-tracker.notification.wallet-buy-more.description": "Wallet {{label}} bought {{amount}} {{ticker}} at {{mcap}} MC. Balance: {{balance}} {{ticker}}.",
  "wallet-tracker.notification.wallet-buy-more.title": "Wallet {{label}} bought more {{ticker}}",
  "wallet-tracker.notification.wallet-first-buy.description": "Wallet {{label}} bought {{amount}} {{ticker}} at {{mcap}} MC for the first time",
  "wallet-tracker.notification.wallet-first-buy.title": "Wallet {{label}} bought {{ticker}}",
  "wallet-tracker.notification.wallet-sell-full.description": "Wallet {{label}} sold all {{amount}} {{ticker}} at {{mcap}} MC",
  "wallet-tracker.notification.wallet-sell-full.title": "Wallet {{label}} sold all {{ticker}}",
  "wallet-tracker.notification.wallet-sell-partial.description": "Wallet {{label}} sold {{amount}} {{ticker}} at {{mcap}} MC. Remaining balance: {{balance}} {{ticker}}.",
  "wallet-tracker.notification.wallet-sell-partial.title": "Wallet {{label}} partially sold {{ticker}}",
  "wallet-tracker.page.title": "Wallet Tracker",
  "wallet-tracker.port.export-description": "Your wallets will be exported here",
  "wallet-tracker.port.export-error": "Unable to download export file",
  "wallet-tracker.port.export-success": "Exported file downloaded successfully",
  "wallet-tracker.port.import-description": "Enter the wallet addresses for import",
  "wallet-tracker.port.import-partial-success": "Wallets({{count}}) imported, {{skipped}} skipped",
  "wallet-tracker.port.import-success": "Wallets({{count}}) have been successfully imported",
  "wallet-tracker.port.import.choose-file": "Choose file",
  "wallet-tracker.port.import.wrong-format": "Import format is wrong",
  "wallet-tracker.port.tab.export": "Export",
  "wallet-tracker.port.tab.import": "Import",
  "wallet-tracker.port.title": "Export/Import Wallets",
  "wallet-tracker.table.alert": "Alert",
  "wallet-tracker.table.label": "Label",
  "wallet-tracker.table.tags": "Tags",
  "wallet-tracker.wallet-address.placeholder": "Enter wallet address",
  "wallet-tracker.wallet-name.placeholder": "Enter wallet name",
  "wallet-tracker.wallet-tags.placeholder": "Enter wallet tags",
  "wallet.add_wallet": "Add wallet",
  "wallet.address_copied_snackbar": "Wallet address copied to clipboard!",
  "wallet.address_input_placeholder": "Enter wallet address",
  "wallet.all_wallets": "All wallets",
  "wallet.change_wallet_color": "Change wallet color",
  "wallet.create.create-new-wallet": "Create new wallet",
  "wallet.create.new-wallet": "New Wallet",
  "wallet.create.seed-phrase-check-boxes": "Check all the boxes to confirm that you understand the importance of your seed phrase",
  "wallet.create.seed-phrase-title": "This seed phrase is a master access to your wallet",
  "wallet.create.seed-phrase-warning": "Never pass this keyword on to anyone and keep it in a safe place.",
  "wallet.create.seed-phrase-words-selection-description": "Select the words from your seed phrase by the appropriate number",
  "wallet.create.success-message": "Your new wallet has been successfully created",
  "wallet.create.word": "Word",
  "wallet.delete_confirmation.description": "You are about to delete this wallet. This action will permanently remove the wallet from the app.",
  "wallet.delete_confirmation.subtitle": "Do you really want to delete your wallet?",
  "wallet.delete_wallet": "Delete wallet",
  "wallet.delete_wallet.failure": "Unable to delete wallet {{walletName}}",
  "wallet.delete_wallet.success": "Wallet {{walletName}} has been successfully deleted",
  "wallet.deleting_a_wallet": "Delete wallet",
  "wallet.deposit": "Please deposit only from a {{network}} wallet to avoid losing funds.",
  "wallet.distribute": "Distribute",
  "wallet.distribute.add-wallet": "Add wallet",
  "wallet.distribute.add-wallets": "Add wallets",
  "wallet.distribute.error.insufficient-balance": "Insufficient balance",
  "wallet.distribute.error.no-targets": "Select targets",
  "wallet.distribute.error.no-wallet": "Select wallet",
  "wallet.distribute.header-description": "Choose wallet and asset to distribute",
  "wallet.distribute.processing-title": "Processing token distribution",
  "wallet.distribute.select-asset": "Select asset",
  "wallet.distribute.unlock-tooltip": "The amount you entered is fixed now, you can click on lock icon to keep it automatically calculated",
  "wallet.export_wallet": "Export wallet",
  "wallet.export_wallet.copied-note": "{{subject}} is copied to clipboard!",
  "wallet.export_wallet.description": "Please read the following carefully before viewing your recovery phrase.",
  "wallet.export_wallet.do_not_share_recovery_phrase": "Support never asks for a recovery phrase.",
  "wallet.export_wallet.recovery_phrase_warning": "Everybody with your recovery phrase can access your wallet.",
  "wallet.export_wallet.storing_warning": "Write down your recovery phrase and store it in a secure offline location.",
  "wallet.favorite": "Favorite",
  "wallet.funds-management": "Funds Management",
  "wallet.import_wallet": "Import wallet",
  "wallet.import.already-exists": "Wallet already exists",
  "wallet.import.enter_your_private_key": "Enter your private key",
  "wallet.import.enter_your_secret_phrase": "Enter your secret phrase",
  "wallet.import.error": "Unable to import wallet",
  "wallet.import.invalid-private-key": "Invalid private key",
  "wallet.import.invalid-seed-phrase": "Invalid seed phrase",
  "wallet.import.name": "Enter wallet name",
  "wallet.import.phrase_hint": "Typically 12 (sometimes 18, 24) words separated by single spaces",
  "wallet.import.phrase-hint-ton": "12 or 24 words separated by single spaces",
  "wallet.import.success": "Wallet was successfully imported",
  "wallet.instant_dialog.no_wallets": "There are no wallets",
  "wallet.instant_dialog.open_first": "open your first",
  "wallet.list-wallets.error.description": "Unexpected error while loading wallets",
  "wallet.list-wallets.error.title": "Unable to load wallets",
  "wallet.manage-assets": "Manage assets",
  "wallet.no_favorite_wallets_message": "You don't have favorite wallets",
  "wallet.no_wallets_description": "It's easy — you can create a new wallet in just a few steps below.",
  "wallet.no_wallets_title": "You haven’t created any wallets yet",
  "wallet.no_wallets.banner.sub-title": "Create your first wallet to unlock full access",
  "wallet.no_wallets.banner.title": "Start Trading Now!",
  "wallet.open_wallet": "Open wallet",
  "wallet.operations": "Wallet Operations",
  "wallet.phrase": "Phrase",
  "wallet.private_key": "Private Key",
  "wallet.refresh-wallet": "Refresh Wallet",
  "wallet.rename_wallet": "Rename wallet",
  "wallet.rename_wallet_short": "Rename",
  "wallet.reorder_wallets.failure": "Failed to reorder wallets",
  "wallet.reorder-aria-label": "Reorder wallet",
  "wallet.search_by_name_address": "Wallet name or address...",
  "wallet.search-wallet": "Search wallet",
  "wallet.secret_phrase": "Secret phrase",
  "wallet.select_wallet": "Select Wallet",
  "wallet.stats.daily_flow": "Daily flow",
  "wallet.stats.summary": "Summary",
  "wallet.stats.top_profit": "Top profit",
  "wallet.updated_error": "Unable to update {{wallet}}",
  "wallet.updated_success": "{{wallet}} has been updated!",
  "wallet.wallet_color": "Wallet color",
  "wallet.wallet_name": "Wallet name",
  "wallet.your_assets": "Your Assets",
  "withdraw": "Withdraw"
}
